<template>
  <head>
    <meta charset="utf-8" />
    <title>Desk Birdy | Land Rate Register</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />
    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <!-- slick carousel -->
    <link rel="stylesheet" href="assets/libs/slick/slick.css"/>
    <link rel="stylesheet" href="assets/libs/slick/slick-theme.css"/>
    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <!-- owl.carousel css -->
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>

    <!-- Start right Content here -->
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row ">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Land Rate Register</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Land & Plots</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Land Rate Register</a></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- tool bar -->
          <ToolBarPlot/>
          <!-- end of toolbar -->


          <div class="row">
            <div class="col-12 px-sm-30px">
              <div class="card">
                <div class="card-header bg-white w-100 border-bottom d-flex justify-content-between align-items-center">
                  <h4 class="card-title text-capitalize">Land Rate Register</h4>

                  <div class="d-flex">
                    <button v-if="getRight('LAND WAIVER SETUP')" data-bs-toggle="modal" data-bs-target=".waiver-setup-modal" type="button" class="btn btn-warning text-uppercase dropdown-toggle option-selector me-3">
                      <i class="mdi mdi-percent-outline font-size-16"></i> <span class="pl-1 d-md-inline">Waiver Setup</span>
                    </button>

                    <button v-if="getRight('LAND ADD PROPERTY')" data-bs-toggle="modal" data-bs-target=".add-plot-modal" type="button" class="btn btn-success text-uppercase dropdown-toggle option-selector me-3">
                      <i class="bx bx-plus font-size-16"></i> <span class="pl-1 d-md-inline">Add Property</span>
                    </button>

                    <button v-if="getRight('LAND UPLOAD PROPERTY SHEET')" data-bs-toggle="modal" data-bs-target=".upload-plot-modal" type="button" class="btn btn-info text-uppercase dropdown-toggle option-selector me-3">
                      <i class="mdi mdi-file-document-outline font-size-16"></i> <span class="pl-1 d-md-inline">Upload Property Sheet</span>
                    </button>

                    <button v-if="getRight('LAND ADD BLOCK')" data-bs-toggle="modal" data-bs-target=".add-block-modal" type="button" class="btn btn-secondary text-uppercase dropdown-toggle option-selector me-3">
                      <i class="mdi mdi-layers-plus font-size-16"></i> <span class="pl-1 d-md-inline">Add A Block</span>
                    </button>

                    <button v-if="getRight('LAND USE KEY')" data-bs-toggle="modal" data-bs-target=".land-use-modal" type="button" class="btn btn-warning text-uppercase dropdown-toggle option-selector me-3">
                      <i class="mdi mdi-key font-size-16"></i> <span class="pl-1 d-md-inline">Land Use Key</span>
                    </button>
                  </div>


                </div>

                <!-- Search section -->
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input v-model="keyword" type="text" class="form-control bg-light border-light rounded" placeholder="Search..." fdprocessedid="husj3l" spellcheck="false" data-ms-editor="true">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Filters section -->
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="d-flex flex-wrap">
                      <select class="form-select w-auto font-13px mx-3" v-model="subCounty">
                        <option value="10">All Sub Counties</option>
                        <option :key="index" :value="item" v-for="(item, index) in subCounties">
                          {{ item.subCountyName }}
                        </option>
                      </select>

                      <select class="form-select w-auto font-13px mx-3" v-model="ward">
                        <option value="10">All Wards</option>
                        <option :key="index" :value="item" v-for="(item, index) in wards">
                          {{ item.wardName }}
                        </option>
                      </select>

                      <div class="d-flex align-items-center me-3 pe-3">
                        <span class="pr-3 fw-semibold text-nowrap">From (Registration Date):</span>
                        <input v-model="dateFrom" class="form-control" placeholder="Start date" type="date">
                        <span class="px-3 fw-semibold">TO:</span>
                        <input v-model="dateTo" class="form-control" placeholder="Start date" type="date">
                      </div>

                      <!-- Enhanced Download Buttons -->
                      <div class="btn-group me-3" role="group">
                        <button
                            @click="downloadCurrentPage()"
                            type="button"
                            class="btn btn-success"
                            :disabled="properties.length === 0">
                          <i class="bx bxs-download font-size-16"></i>
                          <span class="ms-1">Current Page</span>
                        </button>

                        <button
                            @click="downloadAllRecords()"
                            type="button"
                            class="btn btn-primary"
                            :disabled="isDownloadingAll || summary.count === 0">
                          <span v-if="isDownloadingAll">
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                            Downloading...
                          </span>
                          <span v-else>
                            <i class="bx bxs-cloud-download font-size-16"></i>
                            <span class="ms-1">All ({{ numberFormat(summary.count) }})</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Enhanced Main data table -->
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table align-middle table-striped table-nowrap table-hover dt-responsive contacts-table">
                      <thead class="table-dark">
                      <tr>
                        <th scope="col">UPN / LR No.</th>
                        <th>Owner Details</th>
                        <th>Location</th>
                        <th>Annual Land Rates</th>
                        <th>Annual Ground Rent</th>
                        <th>Land Rates Arrears</th>
                        <th>Ground Rent Arrears</th>
                        <th>Accumulated Penalty</th>
                        <th>Accumulated Interest</th>
                        <th>Total Payments</th>
                        <th>Current Balance</th>
                        <th>Status</th>
                        <th>Added By</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody class="text-capitalize">
                      <tr :key="index" v-for="(item, index) in properties">
                        <!-- UPN / LR Number -->
                        <td style="min-width: 140px;">
                          <div class="d-flex flex-column">
                            <strong class="text-primary">{{item.UPN}}</strong>
                            <span class="badge bg-secondary mt-1">Plot: {{item.LRNumber}}</span>
                          </div>
                        </td>

                        <!-- Owner Details -->
                        <td style="min-width: 200px;">
                          <div>
                            <strong>{{item.ownerNames}}</strong>
                            <div v-if="item.ownerPhoneNo" class="text-muted small mt-1">
                              <i class="bx bx-phone text-success"></i> {{maskPhoneNumber(item.ownerPhoneNo)}}
                            </div>
                            <div v-if="item.ownerEmail" class="text-muted small">
                              <i class="bx bx-envelope text-primary"></i> {{item.ownerEmail}}
                            </div>
                            <div v-if="item.percelAddress" class="text-muted small">
                              <i class="bx bx-map-pin text-warning"></i> {{item.percelAddress}}
                            </div>
                            <div v-if="item.percelSize && item.percelSize > 0" class="text-muted small">
                              <i class="bx bx-area text-info"></i> {{numberFormat(item.percelSize)}} Ha
                            </div>
                          </div>
                        </td>

                        <!-- Location -->
                        <td style="min-width: 180px;">
                          <div>
                            <div class="fw-bold">{{item.subCountyName}}</div>
                            <div v-if="item.wardName" class="text-muted small">Ward: {{item.wardName}}</div>
                            <div v-if="item.zone" class="small mt-1">
                              <span class="badge bg-info">{{item.zone}}</span>
                            </div>
                            <div v-if="item.block" class="text-muted small">Block: {{item.block}}</div>
                          </div>
                        </td>

                        <!-- Annual Land Rates -->
                        <td style="min-width: 120px;">
                          <div class="text-end">
                            <div class="fw-bold text-success">
                              KES {{numberFormat(item.annualLandRates || 0)}}
                            </div>
                            <small class="text-muted">Annual Rate</small>
                          </div>
                        </td>

                        <!-- Annual Ground Rent -->
                        <td style="min-width: 120px;">
                          <div class="text-end">
                            <div class="fw-bold text-info">
                              KES {{numberFormat(item.annualGroundRent || 0)}}
                            </div>
                            <small class="text-muted">Annual Rent</small>
                          </div>
                        </td>

                        <!-- Land Rates Arrears -->
                        <td style="min-width: 120px;">
                          <div class="text-end">
                            <div class="fw-bold" :class="item.landRatesArrears > 0 ? 'text-danger' : 'text-muted'">
                              KES {{numberFormat(item.landRatesArrears || 0)}}
                            </div>
                            <small class="text-muted">Rates Arrears</small>
                          </div>
                        </td>

                        <!-- Ground Rent Arrears -->
                        <td style="min-width: 120px;">
                          <div class="text-end">
                            <div class="fw-bold" :class="item.groundRentArrears > 0 ? 'text-danger' : 'text-muted'">
                              KES {{numberFormat(item.groundRentArrears || 0)}}
                            </div>
                            <small class="text-muted">Rent Arrears</small>
                          </div>
                        </td>

                        <!-- Accumulated Penalty -->
                        <td style="min-width: 110px;">
                          <div class="text-end">
                            <div class="fw-bold" :class="item.accumPenalty > 0 ? 'text-warning' : 'text-muted'">
                              KES {{numberFormat(item.accumPenalty || 0)}}
                            </div>
                            <small class="text-muted">Penalty</small>
                          </div>
                        </td>

                        <!-- Accumulated Interest -->
                        <td style="min-width: 110px;">
                          <div class="text-end">
                            <div class="fw-bold" :class="item.accumInterest > 0 ? 'text-warning' : 'text-muted'">
                              KES {{numberFormat(item.accumInterest || 0)}}
                            </div>
                            <small class="text-muted">Interest</small>
                          </div>
                        </td>

                        <!-- Total Payments -->
                        <td style="min-width: 120px;">
                          <div class="text-end">
                            <div class="fw-bold text-primary">
                              KES {{numberFormat(item.payments || 0)}}
                            </div>
                            <small class="text-muted">Total Paid</small>
                          </div>
                        </td>

                        <!-- Current Balance -->
                        <td style="min-width: 120px;">
                          <div class="text-end">
                            <div class="fw-bold" :class="item.currentBalance > 0 ? 'text-danger' : 'text-success'">
                              KES {{numberFormat(item.currentBalance || 0)}}
                            </div>
                          </div>
                        </td>

                        <!-- Status -->
                        <td style="min-width: 100px;">
                          <div class="text-center">
                            <span v-if="item.status === 'Active'" class="badge rounded-pill bg-success text-uppercase">Active</span>
                            <span v-else-if="item.status === 'Suspended'" class="badge rounded-pill bg-danger text-uppercase">Suspended</span>
                            <span v-else-if="item.status === 'Rate Struck'" class="badge rounded-pill bg-warning text-uppercase text-dark">Rate Struck</span>
                            <span v-else-if="item.status === 'Subdivided'" class="badge rounded-pill bg-info text-uppercase">Subdivided</span>
                            <span v-else class="badge rounded-pill bg-secondary text-uppercase">{{item.status || 'Active'}}</span>
                            <div class="text-muted small mt-1">{{formatDate(item.dateCreated)}}</div>
                          </div>
                        </td>

                        <!-- Added By -->
                        <td style="min-width: 140px;">
                          <div>
                            <div class="fw-bold">{{item.createdBy}}</div>
                            <small class="text-muted">ID: {{item.createdByIDNo}}</small>
                          </div>
                        </td>

                        <!-- Enhanced Actions -->
                        <td style="min-width: 140px;">
                          <div class="dropdown">
                            <button role="button" data-bs-toggle="dropdown" aria-haspopup="true" class="btn btn-sm btn-warning text-black waves-effect btn-label waves-light text-uppercase">
                              <i class="mdi mdi-arrow-down-drop-circle label-icon"></i> Options
                            </button>

                            <div class="dropdown-menu dropdown-menu-end">

                              <a v-if="getRight('LAND PLOT DETAILS')" @click="selectPlot(item,'')" class="dropdown-item" href="javascript: void(0);" data-toggle="modal" data-target=".details-modal">
                                <i class="font-size-15 mdi mdi-eye-plus-outline me-3"></i>Plot Details
                              </a>

                              <!-- Corrected (Bootstrap 5) -->

                              <a v-if="getRight('LAND BILL CLIENT')" @click="openBillingModal(item)" class="dropdown-item" href="javascript: void(0);">
                                <i class="font-size-15 mdi mdi mdi-receipt me-3"></i>Bill Client
                              </a>

                              <!-- New Payment Action -->
<!--                              <a v-if="getRight('LAND PROCESS PAYMENT')" @click="selectPlotForPayment(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".payment-processing-modal">
                                <i class="font-size-15 mdi mdi-cash-multiple me-3 text-success"></i>Process Payment
                              </a>-->

                              <a v-if="getRight('LAND STATEMENTS')" class="dropdown-item" href="javascript: void(0);" @click="goToPropertyStatement(item)">
                                <i class="font-size-15 mdi mdi-file-document-outline me-3"></i>Statements
                              </a>

                              <a v-if="getRight('LAND EDIT')" @click="openEditModal(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".edit-property-modal">
                                <i class="font-size-15 mdi mdi-file-document-edit me-3"></i>Edit Property
                              </a>

                              <a v-if="getRight('LAND TRANSFER')" @click="selectPlot(item,'')" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".property-transfer-modal">
                                <i class="font-size-15 mdi mdi-transfer me-3"></i>Transfer
                              </a>

                              <a v-if="getRight('LAND SUBDIVIDE')" @click="selectPlot(item,'')" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".property-subdivision-modal">
                                <i class="font-size-15 mdi mdi-shape-rectangle-plus me-3"></i>Subdivide
                              </a>

                              <a v-if="item.status !== 'Suspended' && getRight('LAND CAUTION')" @click="handleSuspendProperty(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".property-suspension-modal">
                                <i class="font-size-15 mdi mdi-lock me-3 text-danger"></i>Caution
                              </a>

                              <a v-if="item.status === 'Suspended' && getRight('LAND REINSTATE')" @click="handleReinstateProperty(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".property-reinstatement-modal">
                                <i class="font-size-15 mdi mdi-lock-open-outline me-3 text-success"></i>Reinstate Property
                              </a>

                              <a v-if="item.status !== 'Rate Struck' && getRight('LAND RATE STRUCK')" @click="handleSetRateStruck(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".rate-struck-modal">
                                <i class="font-size-15 mdi mdi-currency-usd-off me-3 text-warning"></i>Mark as Rate Struck
                              </a>

                              <a v-if="item.status === 'Rate Struck' && getRight('LAND REMOVE RATE STRUCK')" @click="handleRemoveRateStruck(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".remove-rate-struck-modal">
                                <i class="font-size-15 mdi mdi-currency-usd me-3 text-success"></i>Remove Rate Struck
                              </a>

                              <a v-if="getRight('LAND SUBDIVISION HISTORY')" @click="selectProperty(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".subdivision-history-modal">
                                <i class="font-size-15 mdi mdi-history me-3"></i>Subdivision History
                              </a>

                              <a v-if="getRight('LAND DELETE')" @click="deleteLandRate(item)" class="dropdown-item">
                                <i class="font-size-15 mdi mdi-delete-alert me-3"></i>Delete
                              </a>

                              <a v-if="getRight('LAND DEMAND NOTICE')" @click="selectPlot(item,'')" class="dropdown-item" href="javascript: void(0);" data-toggle="modal" data-target="#demandNotice">
                                <i class="font-size-15 mdi mdi-alert-outline me-2 me-3 text-danger"></i>Send Demand Notice
                              </a>

                              <a v-if="getRight('LAND DEMAND NOTICE')"  @click="openBulkModal" class="dropdown-item" href="javascript:void(0);">
                                <i class="mdi mdi-email-multiple me-2"></i>
                                Bulk Send Notices
                              </a>


                              <a v-if="getRight('LAND BALANCE ADJUSTMENT')" @click="handleOpenAdjustmentModal(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".adjustment-modal">
                                <i class="font-size-15 mdi mdi-cash-refund me-3 text-primary"></i>Balance Adjustment
                              </a>

                              <a v-if="getRight('LAND ADJUSTMENT HISTORY')" @click="handleShowAdjustmentHistory(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".adjustment-history-modal">
                                <i class="font-size-15 mdi mdi-history me-3"></i>Adjustment History
                              </a>

                              <a v-if="getRight('LAND AMALGAMATE')" @click="selectPlot(item,'')" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".property-amalgamation-modal">
                                <i class="font-size-15 mdi mdi-call-merge me-3"></i>Amalgamate
                              </a>

                              <a v-if="getRight('LAND AMALGAMATION HISTORY')" @click.prevent="openAmalgamationHistory(item)" class="dropdown-item" href="javascript: void(0);">
                                <i class="font-size-15 mdi mdi-history me-3"></i> Amalgamation History
                              </a>

                              <a v-if="getRight('LAND USE CHANGE')" @click.prevent="handleLandUseChange(item)" class="dropdown-item" href="javascript:void(0);">
                                <i class="font-size-15 mdi mdi-swap-horizontal me-3 text-info"></i>Change Land Use
                              </a>

                            </div>



                          </div>
                        </td>
                      </tr>
                      </tbody>

                      <!-- Enhanced Footer with detailed totals -->
                      <tfoot class="table-dark">
                      <tr>
                        <th>{{properties.length}} Properties</th>
                        <th>
                          <span class="badge rounded-pill bg-success text-uppercase me-1">{{totalActive}}</span>
                          <span class="badge rounded-pill bg-danger text-uppercase">{{totalSuspended}}</span>
                        </th>
                        <th></th>
                        <th class="text-end">
                          <div class="fw-bold">KES {{numberFormat(totalAnnualLandRates)}}</div>
                          <small>Total Annual</small>
                        </th>
                        <th class="text-end">
                          <div class="fw-bold">KES {{numberFormat(totalAnnualGroundRent)}}</div>
                          <small>Total Annual</small>
                        </th>
                        <th class="text-end">
                          <div class="fw-bold text-danger">KES {{numberFormat(totalLandRatesArrears)}}</div>
                          <small>Total Arrears</small>
                        </th>
                        <th class="text-end">
                          <div class="fw-bold text-danger">KES {{numberFormat(totalGroundRentArrears)}}</div>
                          <small>Total Arrears</small>
                        </th>
                        <th class="text-end">
                          <div class="fw-bold text-warning">KES {{numberFormat(totalPenalties)}}</div>
                          <small>Total</small>
                        </th>
                        <th class="text-end">
                          <div class="fw-bold text-warning">KES {{numberFormat(totalInterest)}}</div>
                          <small>Total</small>
                        </th>
                        <th class="text-end">
                          <div class="fw-bold text-primary">KES {{numberFormat(totalPayments)}}</div>
                          <small>Total Paid</small>
                        </th>
                        <th class="text-end">
                          <div class="fw-bold">KES {{numberFormat(totalCurrentBalance)}}</div>
                          <small>Total Balance</small>
                        </th>
                        <th colspan="3"></th>
                      </tr>
                      </tfoot>
                    </table>

                    <!-- Loading state -->
                    <div class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center d-flex justify-content-center" v-if="loading">
                      <div class="p-5 py-0 pt-3">
                        <div class="p-5">
                          <div class="spinner-border text-info m-1" role="status">
                            <span class="sr-only text-uppercase">Loading...</span>
                          </div>
                        </div>
                      </div>
                      <h4 class="text-uppercase">Loading Data</h4>
                      <div class="col-sm-12 col-md-8 col-lg-5">
                        <p>We are fetching the data for you. It will be ready soon. Please wait and have fun. Thank you for your interest.</p>
                      </div>
                    </div>

                    <!-- No results state -->
                    <div class="card-body d-sm-none d-md-block px-5 d-flex flex-column justify-items-center align-items-center text-center" v-if="properties.length<1 & loading === false">
                      <div class="p-5 py-0 pt-3">
                        <img :src="'./assets/images/no-results.png'" alt="No search results" class="img mb-4"/>
                      </div>
                      <h4>No Results To Show</h4>
                      <p>Sorry, we could not find any results that match your search or filter criteria. Please try using different keywords or filters.</p>
                    </div>
                  </div>
                </div>

                <!-- Pagination -->
                <div class="card-footer bg-white">
                  <nav aria-label="Page navigation example" class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                        <span class="pr-3 pb-0 mb-0 font-13px">
                          <span>Rows Per Page</span>
                        </span>
                      <select class="form-select w-auto font-13px" v-model="pageSize">
                        <option value="10">10 Rows</option>
                        <option value="25">25 Rows</option>
                        <option value="50">50 Rows</option>
                        <option value="100">100 Rows</option>
                        <option value="150">150 Rows</option>
                        <option value="200">200 Rows</option>
                        <option value="10000">10,000 Rows</option>
                        <option value="50000">50,000 Rows</option>
                      </select>
                    </div>

                    <ul class="pagination">
                      <li :class="{ disabled: currentPage === 1 }" class="page-item">
                        <a :disabled="currentPage === 1" @click="prevPage" class="page-link" tabindex="-1">Previous</a>
                      </li>
                      <li :class="{ active: currentPage === page }" :key="page" class="page-item" v-for="page in pagination(currentPage, totalPages, 3)">
                        <span class="page-link" v-if="page === '...'">{{ page }}</span>
                        <a @click="goToPage(page)" class="page-link" v-else>{{ page }}</a>
                      </li>
                      <li :class="{ disabled: currentPage === totalPages }" class="page-item">
                        <a :disabled="currentPage === totalPages" @click="nextPage" class="page-link">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Download Progress Modal -->
      <div class="modal fade" id="downloadProgressModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title text-white">
                <i class="bx bxs-download me-2"></i>Downloading All Land Rate Records
              </h5>
            </div>
            <div class="modal-body">
              <div class="text-center mb-3">
                <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status" v-if="!downloadPaused">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div v-else class="mb-3">
                  <i class="bx bx-pause-circle text-warning" style="font-size: 3rem;"></i>
                </div>
                <h5 v-if="!downloadPaused">Please wait while we download your records...</h5>
                <h5 v-else class="text-warning">Download Paused</h5>

                <!-- Estimated Time Remaining -->
                <div v-if="downloadProgress.estimatedTimeRemaining && !downloadPaused" class="mt-2">
                  <p class="text-muted mb-1">
                    <i class="bx bx-time-five me-1"></i>
                    <strong>{{ formatTimeRemaining(downloadProgress.estimatedTimeRemaining) }}</strong> remaining
                  </p>
                  <small class="text-muted">
                    Average speed: {{ downloadProgress.averageSpeed }} records/sec
                  </small>
                </div>

                <p class="text-muted mt-2">{{ downloadPaused ? 'You can resume or cancel the download.' : 'This may take several minutes depending on the amount of data.' }}</p>
              </div>

              <div class="progress mb-3" style="height: 25px;">
                <div
                    class="progress-bar progress-bar-striped"
                    :class="{'progress-bar-animated': !downloadPaused, 'bg-warning': downloadPaused}"
                    role="progressbar"
                    :style="{ width: downloadProgress.percentage + '%' }"
                    :aria-valuenow="downloadProgress.percentage"
                    aria-valuemin="0"
                    aria-valuemax="100">
                  {{ downloadProgress.percentage }}%
                </div>
              </div>

              <div class="d-flex justify-content-between text-muted small mb-3">
                <span>Page {{ downloadProgress.current }} of {{ downloadProgress.total }}</span>
                <span>{{ downloadProgress.records }} / {{ numberFormat(downloadProgress.totalRecords) }} records</span>
              </div>

              <!-- Error Display -->
              <div v-if="downloadError" class="alert alert-danger d-flex align-items-center" role="alert">
                <i class="bx bx-error-circle me-2"></i>
                <div class="flex-grow-1">
                  <strong>Error:</strong> {{ downloadError }}
                  <br>
                  <small>You can retry from where it stopped or cancel the download.</small>
                </div>
              </div>

              <!-- Retry Count Display -->
              <div v-if="downloadRetryCount > 0" class="alert alert-warning d-flex align-items-center mb-3" role="alert">
                <i class="bx bx-info-circle me-2"></i>
                <small>Retry attempt {{ downloadRetryCount }} of 3</small>
              </div>

              <!-- Action Buttons -->
              <div class="d-flex gap-2 justify-content-center mb-3">
                <button
                    v-if="!downloadPaused && !downloadError"
                    @click="pauseDownload"
                    class="btn btn-warning btn-sm">
                  <i class="bx bx-pause me-1"></i>Pause
                </button>
                <button
                    v-if="downloadPaused || downloadError"
                    @click="resumeDownload"
                    class="btn btn-success btn-sm">
                  <i class="bx bx-play me-1"></i>Resume
                </button>
                <button
                    @click="cancelDownload"
                    class="btn btn-danger btn-sm">
                  <i class="bx bx-x me-1"></i>Cancel
                </button>
              </div>

              <div class="alert alert-info d-flex align-items-center" role="alert">
                <i class="bx bx-info-circle me-2"></i>
                <small>{{ downloadPaused ? 'Download is paused. Your progress has been saved.' : 'Please do not close this window or navigate away.' }}</small>
              </div>

              <!-- Download Statistics -->
              <div v-if="downloadProgress.records > 0" class="mt-3 pt-3 border-top">
                <div class="row text-center">
                  <div class="col-4">
                    <small class="text-muted d-block">Downloaded</small>
                    <strong>{{ numberFormat(downloadProgress.records) }}</strong>
                  </div>
                  <div class="col-4">
                    <small class="text-muted d-block">Remaining</small>
                    <strong>{{ numberFormat(downloadProgress.totalRecords - downloadProgress.records) }}</strong>
                  </div>
                  <div class="col-4">
                    <small class="text-muted d-block">Success Rate</small>
                    <strong>{{ getSuccessRate() }}%</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Payment Processing Modal -->
      <div class="modal fade payment-processing-modal" tabindex="-1" role="dialog" aria-labelledby="paymentProcessingModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-success text-white">
              <h5 class="modal-title text-white" id="paymentProcessingModalLabel">
                <i class="mdi mdi-cash-multiple me-2"></i>
                Process Payment - BRD Priority Logic
              </h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <!-- Property Information -->
              <div v-if="selectedPropertyForPayment" class="card mb-4">
                <div class="card-header bg-light">
                  <h6 class="mb-0">Property Details</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <strong>LR Number:</strong> {{ selectedPropertyForPayment.LRNumber }}<br>
                      <strong>Owner:</strong> {{ selectedPropertyForPayment.ownerNames }}<br>
                      <strong>Zone:</strong> {{ selectedPropertyForPayment.zone }}
                    </div>
                    <div class="col-md-6">
                      <strong>Current Balance:</strong> <span class="text-danger">KES {{ numberFormat(selectedPropertyForPayment.currentBalance || 0) }}</span><br>
                      <strong>Land Rates Arrears:</strong> KES {{ numberFormat(selectedPropertyForPayment.landRatesArrears || 0) }}<br>
                      <strong>Ground Rent Arrears:</strong> KES {{ numberFormat(selectedPropertyForPayment.groundRentArrears || 0) }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Payment Form -->
              <div class="card">
                <div class="card-header bg-info text-white">
                  <h6 class="mb-0 text-white">Payment Information</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">Payment Amount *</label>
                        <input v-model="paymentForm.amount" type="number" step="0.01" class="form-control" placeholder="Enter payment amount" required>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Payment Mode *</label>
                        <select v-model="paymentForm.paymentMode" class="form-select" required>
                          <option value="">Select Payment Mode</option>
                          <option value="CASH">Cash</option>
                          <option value="MPESA">M-Pesa</option>
                          <option value="BANK">Bank Transfer</option>
                          <option value="CHEQUE">Cheque</option>
                        </select>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Transaction Code</label>
                        <input v-model="paymentForm.transactionCode" type="text" class="form-control" placeholder="Enter transaction reference">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">Paid By</label>
                        <input v-model="paymentForm.paidBy" type="text" class="form-control" placeholder="Name of person making payment">
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Phone Number</label>
                        <input v-model="paymentForm.phoneNumber" type="text" class="form-control" placeholder="Phone number">
                      </div>
                    </div>
                  </div>

                  <!-- Payment Priority Information -->
                  <div class="alert alert-info mt-3">
                    <h6><i class="mdi mdi-information me-2"></i>Payment Priority (Per BRD):</h6>
                    <ol class="mb-0">
                      <li><strong>Interest</strong> - KES {{ numberFormat(selectedPropertyForPayment?.accumInterest || 0) }}</li>
                      <li><strong>Penalty</strong> - KES {{ numberFormat(selectedPropertyForPayment?.accumPenalty || 0) }}</li>
                      <li><strong>Land Rates Principal</strong> - KES {{ numberFormat(selectedPropertyForPayment?.landRatesArrears || 0) }}</li>
                      <li><strong>Ground Rent Principal</strong> - KES {{ numberFormat(selectedPropertyForPayment?.groundRentArrears || 0) }}</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button @click="processPayment" type="button" class="btn btn-success" :disabled="processingPayment">
                <span v-if="processingPayment">
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Processing...
                </span>
                <span v-else>
                  <i class="mdi mdi-cash-check me-2"></i>
                  Process Payment
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Arrears Report Modal -->
      <div class="modal fade arrears-report-modal" tabindex="-1" role="dialog" aria-labelledby="arrearsReportModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-info text-white">
              <h5 class="modal-title text-white" id="arrearsReportModalLabel">
                <i class="mdi mdi-file-chart me-2"></i>
                Arrears Report by Geographic Levels
              </h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <!-- Report Filters -->
              <div class="card mb-4">
                <div class="card-header bg-light">
                  <h6 class="mb-0">Report Filters</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="form-label">Report Type</label>
                      <select v-model="arrearsReportForm.reportType" @change="generateArrearsReport" class="form-select">
                        <option value="county">County Summary</option>
                        <option value="subcounty">Sub-County Details</option>
                        <option value="ward">Ward Details</option>
                        <option value="zone">Zone Details</option>
                      </select>
                    </div>
                    <div class="col-md-3" v-if="arrearsReportForm.reportType !== 'county'">
                      <label class="form-label">Sub-County</label>
                      <select v-model="arrearsReportForm.subCountyName" @change="generateArrearsReport" class="form-select">
                        <option value="">All Sub-Counties</option>
                        <option :value="item.subCountyName" v-for="item in subCounties" :key="item.subCountyID">
                          {{ item.subCountyName }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3" v-if="arrearsReportForm.reportType === 'ward' || arrearsReportForm.reportType === 'zone'">
                      <label class="form-label">Ward</label>
                      <select v-model="arrearsReportForm.wardName" @change="generateArrearsReport" class="form-select">
                        <option value="">All Wards</option>
                        <option :value="item.wardName" v-for="item in wards" :key="item.wardID">
                          {{ item.wardName }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3" v-if="arrearsReportForm.reportType === 'zone'">
                      <label class="form-label">Zone</label>
                      <select v-model="arrearsReportForm.zone" @change="generateArrearsReport" class="form-select">
                        <option value="">All Zones</option>
                        <option :value="zone" v-for="zone in zones" :key="zone">
                          {{ zone }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Report Results -->
              <div v-if="arrearsReportData && arrearsReportData.length > 0" class="card">
                <div class="card-header bg-success text-white d-flex justify-content-between align-items-center">
                  <h6 class="mb-0 text-white">Arrears Summary</h6>
                  <button @click="downloadArrearsReport" class="btn btn-outline-light btn-sm">
                    <i class="mdi mdi-download me-2"></i>Download CSV
                  </button>
                </div>
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table table-striped mb-0">
                      <thead class="table-dark">
                      <tr>
                        <th>Location</th>
                        <th class="text-end">Properties</th>
                        <th class="text-end">Land Rates Arrears</th>
                        <th class="text-end">Ground Rent Arrears</th>
                        <th class="text-end">Interest</th>
                        <th class="text-end">Penalty</th>
                        <th class="text-end">Total Arrears</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in arrearsReportData" :key="item.location">
                        <td><strong>{{ item.location }}</strong></td>
                        <td class="text-end">{{ numberFormat(item.totalProperties) }}</td>
                        <td class="text-end">KES {{ numberFormat(item.totalLandRatesArrears) }}</td>
                        <td class="text-end">KES {{ numberFormat(item.totalGroundRentArrears) }}</td>
                        <td class="text-end">KES {{ numberFormat(item.totalInterest) }}</td>
                        <td class="text-end">KES {{ numberFormat(item.totalPenalty) }}</td>
                        <td class="text-end"><strong>KES {{ numberFormat(item.totalArrears) }}</strong></td>
                      </tr>
                      </tbody>
                      <tfoot class="table-dark" v-if="arrearsReportTotals">
                      <tr>
                        <th>GRAND TOTAL</th>
                        <th class="text-end">{{ numberFormat(arrearsReportTotals.totalProperties) }}</th>
                        <th class="text-end">KES {{ numberFormat(arrearsReportTotals.grandTotalLandRates) }}</th>
                        <th class="text-end">KES {{ numberFormat(arrearsReportTotals.grandTotalGroundRent) }}</th>
                        <th class="text-end">KES {{ numberFormat(arrearsReportTotals.grandTotalInterest) }}</th>
                        <th class="text-end">KES {{ numberFormat(arrearsReportTotals.grandTotalPenalty) }}</th>
                        <th class="text-end"><strong>KES {{ numberFormat(arrearsReportTotals.grandTotalArrears) }}</strong></th>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Loading State -->
              <div v-if="loadingArrearsReport" class="text-center py-4">
                <div class="spinner-border text-info" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div class="mt-2">Generating report...</div>
              </div>

              <!-- No Data State -->
              <div v-if="!arrearsReportData && !loadingArrearsReport" class="text-center py-4">
                <i class="mdi mdi-chart-line-stacked text-muted" style="font-size: 48px;"></i>
                <h6 class="text-muted mt-3">Select report type to generate arrears summary</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Land Use Change Modal -->
      <div class="modal fade land-use-change-modal" tabindex="-1" role="dialog" aria-labelledby="landUseChangeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-info text-white">
              <h5 class="modal-title text-white" id="landUseChangeModalLabel">
                <i class="mdi mdi-home-switch me-2"></i>
                Change Land Use
              </h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <!-- Selected Property Info -->
              <div v-if="selectedPropertyForLandUse && selectedPropertyForLandUse.LRNumber" class="card mb-4">
                <div class="card-header bg-info text-white">
                  <h6 class="mb-0 text-white">
                    <i class="mdi mdi-home me-2"></i>
                    Selected Property
                  </h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <strong>LR Number:</strong> {{ selectedPropertyForLandUse.LRNumber }}<br>
                      <strong>Owner:</strong> {{ selectedPropertyForLandUse.ownerNames }}<br>
                      <strong>Current Land Use:</strong>
                      <span class="badge bg-secondary">{{ selectedPropertyForLandUse.useName || 'Not Set' }}</span>
                    </div>
                    <div class="col-md-6">
                      <strong>Zone:</strong> {{ selectedPropertyForLandUse.zone }}<br>
                      <strong>Sub County:</strong> {{ selectedPropertyForLandUse.subCountyName }}<br>
                      <strong>Address:</strong> {{ selectedPropertyForLandUse.percelAddress || 'N/A' }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Step 1: Bill Number Input -->
              <div v-if="landUseChangeStep === 1" class="card">
                <div class="card-header bg-light">
                  <h6 class="mb-0">Step 1: Enter Bill Number for Authorization</h6>
                </div>
                <div class="card-body">
                  <div class="alert alert-info">
                    <i class="mdi mdi-information me-2"></i>
                    Enter a paid bill number to authorize the land use change
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Bill Number *</label>
                    <input
                        v-model="landUseBillNumber"
                        type="text"
                        class="form-control"
                        placeholder="Enter bill number (e.g., BLL0901063127758)"
                    >
                  </div>
                  <button
                      @click="verifyBillForLandUse"
                      :disabled="!landUseBillNumber || verifyingBill"
                      class="btn btn-primary">
              <span v-if="verifyingBill">
                <span class="spinner-border spinner-border-sm me-2"></span>
                Verifying...
              </span>
                    <span v-else>
                <i class="mdi mdi-shield-check me-2"></i>
                Verify Payment
              </span>
                  </button>

                  <!-- Error message -->
                  <div v-if="landUseError" class="alert alert-danger mt-3">
                    <i class="mdi mdi-alert-circle me-2"></i>
                    {{ landUseError }}
                  </div>
                </div>
              </div>

              <!-- Step 2: Land Use Selection -->
              <div v-if="landUseChangeStep === 2">
                <!-- Payment Verified -->
                <div class="card mb-4">
                  <div class="card-header bg-success text-white">
                    <h6 class="mb-0 text-white">
                      <i class="mdi mdi-check-circle me-2"></i>
                      Payment Verified - Authorization Granted
                    </h6>
                  </div>
                  <div class="card-body">
                    <strong>Bill:</strong> {{ verifiedBill.billNo }} |
                    <strong>Amount:</strong> KES {{ numberFormat(verifiedBill.detailAmount) }} |
                    <span class="badge bg-success">{{ verifiedBill.status }}</span>
                  </div>
                </div>

                <!-- Land Use Selection -->
                <div class="card">
                  <div class="card-header bg-warning text-dark">
                    <h6 class="mb-0">
                      <i class="mdi mdi-home-edit me-2"></i>
                      Step 2: Select New Land Use
                    </h6>
                  </div>
                  <div class="card-body">
                    <div class="mb-3">
                      <label class="form-label">New Land Use *</label>
                      <select v-model="selectedNewLandUse" class="form-select">
                        <option value="">Select New Land Use</option>
                        <option
                            v-for="use in uses"
                            :key="use.id"
                            :value="use"
                            :disabled="selectedPropertyForLandUse.useName === use.name">
                          {{ use.name }}
                          <span v-if="selectedPropertyForLandUse.useName === use.name"> (Current)</span>
                        </option>
                      </select>
                    </div>

                    <div class="mb-3">
                      <label class="form-label">Reason for Change *</label>
                      <textarea
                          v-model="landUseChangeReason"
                          class="form-control"
                          rows="3"
                          placeholder="Enter reason for land use change..."></textarea>
                    </div>

                    <!-- Change Summary -->
                    <div v-if="selectedNewLandUse" class="alert alert-info">
                      <h6><i class="mdi mdi-information me-2"></i>Change Summary:</h6>
                      <strong>Property:</strong> {{ selectedPropertyForLandUse.LRNumber }}<br>
                      <strong>From:</strong> {{ selectedPropertyForLandUse.useName || 'Not Set' }}<br>
                      <strong>To:</strong> {{ selectedNewLandUse.name }}<br>
                      <strong>Authorized by:</strong> {{ verifiedBill.billNo }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                  v-if="landUseChangeStep === 2"
                  @click="landUseChangeStep = 1"
                  type="button"
                  class="btn btn-secondary">
                <i class="mdi mdi-arrow-left me-2"></i>
                Back
              </button>

              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                Cancel
              </button>

              <button
                  v-if="landUseChangeStep === 2"
                  @click="submitLandUseChange"
                  type="button"
                  class="btn btn-success"
                  :disabled="!selectedNewLandUse || !landUseChangeReason || submittingLandUseChange">
          <span v-if="submittingLandUseChange">
            <span class="spinner-border spinner-border-sm me-2"></span>
            Updating...
          </span>
                <span v-else>
            <i class="mdi mdi-content-save me-2"></i>
            Update Land Use
          </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- All Modal Components -->

      <DemandNoticeModal
          :property="property"
          @print-demand-notice="printDemandNotice"
      />


      <AddPlotModal
          :title="title"
          :property="property"
          :blocks="blocks"
          :uses="uses"
          :sub-counties="subCounties"
          :wards="wards"
          @submit="handleAddPlot"
          @get-wards="getWards"
      />

      <UploadPlotModal
          :template-url="templateURL"
          :sub-counties="subCounties"
          :zones="zones"
          @upload-batch="handleBatchUpload"
          @upload-complete="handleUploadComplete"
          @get-zones="getZones"
      />

      <!-- Upload Result Modal -->
      <UploadResultModal :uploadResult="uploadResult" />

      <PropertyDetailsModal
          :property="property"
      />

      <BillingModal
          :property="property"
          :income-types="billingModule.incomeTypes"
          :fees-and-charges="feesAndCharges"
          @generate-bill="generateBill"
          @income-type-changed="selectedIncomeType"
          @fee-type-changed="selectedFeeAndCharge"
      />

      <PaymentModal
          :payment-panel="paymentPanel"
          :payment-method="paymentMethod"
          :transaction-summary="transactionSummary"
          :transaction-completed="transactionCompleted"
          :bill-details="billDetails"
          :receipt-details="receiptDetails"
          :message="message"
          @show-payment-method="showPaymentMethod"
          @print-bill="printBill"
          @make-payment="makePayment"
          @print-receipt="printReceipt"
          @show-transaction-summary="showTransactionSummary"
      />

      <AddBlockModal
          :blocks="blocks"
          :sub-counties="subCounties"
          :wards="wards"
          @submit="handleAddBlock"
          @get-wards="getWards"
      />

      <PropertyStatusModals
          :property="property"
          @suspend-property="confirmSuspendProperty"
          @reinstate-property="confirmReinstateProperty"
          @set-rate-struck="confirmSetRateStruck"
          @remove-rate-struck="confirmRemoveRateStruck"
      />

      <AdjustmentModals
          :property="property"
          :adjustment-history="adjustmentHistory"
          @make-adjustment="confirmAdjustment"
      />

      <LandUseModal />

      <!-- Existing separate components -->
      <PropertyTransfer />
      <WaiverSetup/>
      <PropertySubdivision
          :property="property"
          @refresh="getLandRates"
      />
      <SubdivisionHistory
          :property-id="property.id"
          :lr-number="property.LRNumber"
      />
      <PropertyAmalgamation
          :property="property"
          @refresh="getLandRates"
          @viewProperty="viewProperty"
      />
      <AmalgamationHistory
          ref="amalgamationHistory"
          :property="property"
          @viewProperty="viewProperty"
      />


      <EditPropertyModal
          :property="propertyToEdit"
          :blocks="blocks"
          :uses="uses"
          :sub-counties="subCounties"
          :wards="wards"
          @get-wards="getWards"
          @property-updated="handlePropertyUpdated"
      />

      <BulkDemandNoticeModal ref="bulkModal" />


      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import moment from "moment/moment";
import {base,authUrl, biller, execute, execute2, executeDownload, executeJson, getRight, landRate} from "@/api";
import router from "@/router";
import ToolBarPlot from "@/components/landrate/ToolBar.vue";
import PropertyTransfer from "@/components/landrate/PropertyTransfer.vue";
import PropertySubdivision from "@/components/landrate/PropertySubdivision.vue";
import SubdivisionHistory from "@/components/landrate/SubdivisionHistory.vue";
import WaiverSetup from "@/components/landrate/WaiverSetup.vue";
import PropertyAmalgamation from "@/components/landrate/PropertyAmalgamation.vue";
import AmalgamationHistory from "@/components/landrate/AmalgamationHistory.vue";

// Import new modal components
import DemandNoticeModal from "@/components/landrate/modals/DemandNoticeModal.vue";
import AddPlotModal from "@/components/landrate/modals/AddPlotModal.vue";
import UploadPlotModal from "@/components/landrate/modals/UploadPlotModal.vue";
import UploadResultModal from "@/components/landrate/modals/UploadResultModal.vue";
import PropertyDetailsModal from "@/components/landrate/modals/PropertyDetailsModal.vue";
import BillingModal from "@/components/landrate/modals/BillingModal.vue";
import PaymentModal from "@/components/landrate/modals/PaymentModal.vue";
import AddBlockModal from "@/components/landrate/modals/AddBlockModal.vue";
import PropertyStatusModals from "@/components/landrate/modals/PropertyStatusModals.vue";
import AdjustmentModals from "@/components/landrate/modals/AdjustmentModals.vue";
import LandUseModal from "@/components/landrate/modals/LandUseModal.vue";
import LandUseChange from "@/components/landrate/modals/LandUseChange.vue";
import BulkDemandNotice from "@/components/landrate/modals/BulkDemandNoticeModal.vue";
import BulkDemandNoticeModal from '@/components/landrate/modals/BulkDemandNoticeModal.vue'
import EditPropertyModal from "@/components/landrate/modals/EditPropertyModal.vue";

export default {
  name: "LandRate",
  components: {
    EditPropertyModal,
    BulkDemandNoticeModal,
    BulkDemandNotice,
    ToolBarPlot,
    NavigationBar,
    PropertyTransfer,
    PropertySubdivision,
    SubdivisionHistory,
    WaiverSetup,
    PropertyAmalgamation,
    AmalgamationHistory,
    DemandNoticeModal,
    AddPlotModal,
    UploadPlotModal,
    UploadResultModal,
    PropertyDetailsModal,
    BillingModal,
    PaymentModal,
    AddBlockModal,
    PropertyStatusModals,
    AdjustmentModals,
    LandUseModal,
    LandUseChange
  },
  data() {
    return {
      propertyToEdit: {},
      selectedPropertyForLandUse: null,
      landUseChangeStep: 1,
      landUseBillNumber: '',
      verifiedBill: null,
      selectedNewLandUse: null,
      landUseChangeReason: '',
      verifyingBill: false,
      submittingLandUseChange: false,
      landUseError: '',

      adjustmentHistory: [],
      demandNotice: false,
      generateBillLoading: false,
      templateURL: base+"/templates/LANDRATE_DATA_TEMPLATE.xlsx",

      // Upload result tracking
      uploadResult: {
        successful: 0,
        failed: 0,
        totalProcessed: 0,
        message: '',
        failedRecords: []
      },
      isSelectingPlot: false,

      // Enhanced download functionality with pause/resume and time estimation
      isDownloadingAll: false,
      downloadPaused: false,
      downloadCancelled: false,
      downloadError: null,
      downloadRetryCount: 0,
      maxRetries: 3,
      downloadProgress: {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      },
      allRecordsData: [],
      downloadState: {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      },

      // Enhanced penalty management data
      processingInterest: false,
      processingPenalty: false,
      processingStatus: null,
      lastProcessingSummary: {
        interest: null,
        penalty: null
      },

      // Payment processing data
      selectedPropertyForPayment: null,
      processingPayment: false,
      paymentForm: {
        amount: 0,
        paymentMode: '',
        transactionCode: '',
        paidBy: '',
        phoneNumber: ''
      },

      // Arrears report data
      arrearsReportForm: {
        reportType: 'county',
        subCountyName: '',
        wardName: '',
        zone: ''
      },
      arrearsReportData: null,
      arrearsReportTotals: null,
      loadingArrearsReport: false,

      useName:'',
      uses:[{
        id:null,
        name:null
      }],
      blocks:[{
        id: null,
        block: null,
        subCountyName: null,
        subCountyID: null,
        wardName: null,
        wardID: null,
      }],
      block:'',
      title:'',
      feeID:'',
      amount:0,
      unitFeeAmount:0,
      quantity: 1,
      subCountyName:'',
      wardName:'',
      dateFrom:'',
      dateTo:'',
      searchValue:"",
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      download:'Download Report',
      loading: false,
      keyword:'',
      color:'alert-success',
      subCountyID:'',
      wardID:'',
      subCounties:[{
        subCountyID: "",
        subCountyName: ""
      }],
      wards:[{
        wardID: "",
        wardName: ""
      }],
      subCounty: {
        id:"",
        countyID:"",
        countyName:"",
        subCountyID:"",
        subCountyName:"",
        wardID:"",
        wardName:"",
        status:""
      },
      ward:{
        id:"",
        countyID:"",
        countyName:"",
        subCountyID:"",
        subCountyName:"",
        wardID:"",
        wardName:"",
        status:""
      },
      billingModule:{
        incomeType:{
          incomeTypeId: null,
          incomeTypeDescription:null,
          incomeTypePrefix: null,
          fundDescription: null,
          status: null
        },
        incomeTypes:[{
          incomeTypeId: null,
          incomeTypeDescription:null,
          incomeTypePrefix: null,
          fundDescription: null,
          status: null}]
      },
      properties: [{
        id: null,
        UPN: null,
        LRNumber: null,
        subCountyName: null,
        subCountyID: null,
        wardName: null,
        wardID: null,
        plotSize: null,
        lat: null,
        lng: null,
        percelAddress: null,
        ownerNames: null,
        ownerEmail: null,
        ownerPhoneNo: null,
        outstandingArrears: null,
        annualCharges: null,
        createdBy: null,
        createdByIDNo: null,
        dateCreated: null,
        status: null,
        zone:null,
        landRatesArrears: null,
        groundRentArrears: null,
        accumPenalty: null,
        accumInterest: null,
        annualLandRates: null,
        annualGroundRent: null,
        payments: null,
        currentBalance: null
      }],
      property: {
        id: null,
        upn: "",
        UPN: null,
        LRNumber: null,
        subCountyName: null,
        subCountyID: null,
        subCounty: null,
        wardName: null,
        wardID: null,
        percelSize: null,
        lat: null,
        lng: null,
        percelAddress: null,
        ownerNames: null,
        ownerEmail: null,
        ownerPhoneNo: null,
        outstandingArrears: null,
        annualCharges: null,
        createdBy: null,
        createdByIDNo: null,
        dateCreated: null,
        status: null,
        zone: null,
        block: null,
        useName: null,
        ownerPassport: null,
        ownerDrivingLicence: null,
        ownerPassportNonKenyan: null,
        registrationCertificate: null,
        pinNumber: null,
        boxNo: null,
        postalCode: null,
        town: null,
        physicalAddress: null,
        coOwnerNames: null,
        coOwnerID: null,
        coOwnerPassport: null,
        coOwnerDrivingLicence: null,
        coOwnerPassportNonKenyan: null,
        coOwnerRegistrationCertificate: null,
        coOwnerPinNumber: null,
        coOwnerBoxNo: null,
        coOwnerPostalCode: null,
        coOwnerTown: null,
        coOwnerPhysicalAddress: null,
        coOwnerPhoneNo: null,
        coOwnerEmail: null,
        suspensionReason: null,
        dateSuspended: null,
        suspendedBy: null,
        rateStruckReason: null,
        dateRateStruck: null,
        rateStruckBy: null,
        dateReinstated: null,
        reinstatedBy: null,
        dateRateStruckRemoved: null,
        rateStruckRemovedBy: null
      },
      totalUncomplint:0,
      totalCompliant:0,
      totalArrears:0,
      totalAnnual:0,
      totalBalance:0,
      feesAndCharges:[{
        feeId: null,
        feeDescription: null,
        unitOfMeasure: null,
        unitFeeAmount: null,
        accountNo: null,
        incomeTypeId: null,
        feeType: null,
        accountDesc:null ,
        costCenterNo:null,
        zone: null,
        typeDescription: null
      }],
      selectedProperties:[{
        id: null,
        LRNumber: null,
        subCounty: null,
        subCountyID: null,
        wardName: null,
        wardID: null,
        percelSize: null,
        lat: null,
        lng: null,
        percelAddress: null,
        ownerNames: null,
        ownerEmail: null,
        ownerPhoneNo: null,
        outstandingArrears: null,
        annualCharges: null,
        createdBy: null,
        createdByIDNo: null,
        dateCreated: null,
        status: null,
        block: null,
        useName:null,
      }],
      totalAmount:0,
      message:null,
      feesAndChargeItems:[{
        feeId: null,
        feeDescription: null,
        unitOfMeasure: null,
        unitFeeAmount: null,
        accountNo: null,
        incomeTypeId: null,
        feeType: null,
        accountDesc:null ,
        costCenterNo:null,
        zone: null,
        typeDescription: null,
        customer: null,
        quantity:null,
      }],
      billItem:[],
      billDetails:{
        id:'',
        billNo:'',
        incomeTypeID:'',
        incomeTypeDescription:'',
        costCenterNo:'',
        accountNo:'',
        feeID:'',
        detailAmount:'',
        receiptAmount:'',
        billBalance:'',
        wardID:'',
        subCountyID:'',
        status:'',
        dateCreated:''
      },
      billInfo:[],
      paymentData: {
        bankReceiptNo: null,
        accNo: null,
        payBillNo: null,
        amount: null,
        phoneNumber: null,
        success: false,
        paymentMode:null,
        sessionNames:null,
        sessionIdNo:null,
        sessionPhoneNumber:null
      },
      alert:{
        success: false,
        info: false,
        failed:false
      },
      transactionCompleted: false,
      transactionSummary: false,
      paymentPanel: true,
      paymentMethod: false,
      zone:'',
      zones: [],
      summary:{
        count:0
      },
      receiptDetails: {},
      phoneNumber: ''
    }
  },
  watch:{
    pageSize(newPageSize) {

      if (!this.isSelectingPlot) {
        this.getLandRates()
      }


      const totalItems = this.summary.count;
      const newTotalPages = Math.ceil(totalItems / newPageSize);
      this.totalPages = newTotalPages;
      this.currentPage = 1;
    },
    subCounty: function () {
      this.subCountyID = this.subCounty.subCountyID
      this.subCountyName = this.subCounty.subCountyName

      if (!this.isSelectingPlot) {
        this.getLandRates()
        this.getWards()
      }
    },
    ward: function () {
      this.wardID = this.ward.wardID
      this.wardName = this.ward.wardName
      if (!this.isSelectingPlot) {
        this.getLandRates()
      }
    },
    quantity: function () {
      this.amount = this.quantity * this.unitFeeAmount;
    }
  },
  mounted() {
    this.getLandRates()
    this.getSubCounties()

    this.$watch('keyword', function(newValue) {
      this.keyword = newValue;
      this.getLandRates()
    })

    this.$watch('dateFrom', function() {
      if(this.dateFrom==='' || this.dateTo===''){
      }else{
        this.getLandRates()
      }
    })

    this.$watch('dateTo', function() {
      if(this.dateFrom==='' || this.dateTo===''){
      }else{
        this.getLandRates()
      }
    })

    this.subCountyID = sessionStorage.getItem("sessionSubCountyID")
    this.wardID = sessionStorage.getItem("sessionWardID")
    this.getLandRates()
    this.getIncomeTypes()
    this.getBlocks()
    this.getUses()
    this.menuAccess()
  },
  computed:{
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    endIndex() {
      return this.currentPage * this.pageSize;
    },
    totalActive() {
      return this.properties.filter(p => p.status === 'Active').length;
    },
    totalSuspended() {
      return this.properties.filter(p => p.status === 'Suspended').length;
    },
    totalAnnualLandRates() {
      return this.properties.reduce((acc, cur) => {
        return acc + (parseFloat(cur.annualLandRates) || 0);
      }, 0);
    },
    totalAnnualGroundRent() {
      return this.properties.reduce((acc, cur) => {
        return acc + (parseFloat(cur.annualGroundRent) || 0);
      }, 0);
    },
    totalLandRatesArrears() {
      return this.properties.reduce((acc, cur) => {
        return acc + (parseFloat(cur.landRatesArrears) || 0);
      }, 0);
    },
    totalGroundRentArrears() {
      return this.properties.reduce((acc, cur) => {
        return acc + (parseFloat(cur.groundRentArrears) || 0);
      }, 0);
    },
    totalPenalties() {
      return this.properties.reduce((acc, cur) => {
        return acc + (parseFloat(cur.accumPenalty) || 0);
      }, 0);
    },
    totalInterest() {
      return this.properties.reduce((acc, cur) => {
        return acc + (parseFloat(cur.accumInterest) || 0);
      }, 0);
    },
    totalPayments() {
      return this.properties.reduce((acc, cur) => {
        return acc + (parseFloat(cur.payments) || 0);
      }, 0);
    },
    totalCurrentBalance() {
      return this.properties.reduce((acc, cur) => {
        return acc + (parseFloat(cur.currentBalance) || 0);
      }, 0);
    }
  },
  methods: {

    // =============================================
    // NEW DOWNLOAD METHODS WITH PAUSE/RESUME
    // =============================================

    /**
     * Format time remaining in human-readable format
     */
    formatTimeRemaining(seconds) {
      if (!seconds || seconds <= 0) return 'Calculating...';

      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);

      if (hours > 0) {
        return `${hours}h ${minutes}m ${secs}s`;
      } else if (minutes > 0) {
        return `${minutes}m ${secs}s`;
      } else {
        return `${secs}s`;
      }
    },

    /**
     * Calculate estimated time remaining
     */
    calculateEstimatedTime() {
      if (!this.downloadProgress.startTime || this.downloadProgress.current === 0) {
        return;
      }

      const elapsedTime = (Date.now() - this.downloadProgress.startTime) / 1000;
      const recordsDownloaded = this.downloadProgress.records;
      const remainingRecords = this.downloadProgress.totalRecords - recordsDownloaded;

      if (recordsDownloaded > 0 && elapsedTime > 0) {
        const averageSpeed = recordsDownloaded / elapsedTime;
        this.downloadProgress.averageSpeed = averageSpeed.toFixed(2);

        const estimatedTimeRemaining = remainingRecords / averageSpeed;
        this.downloadProgress.estimatedTimeRemaining = estimatedTimeRemaining;
      }
    },

    /**
     * Download Current Page (Client-side CSV generation)
     */
    downloadCurrentPage() {
      if (this.properties.length === 0) {
        alert('No data available to download');
        return;
      }

      try {
        const csv = this.generateLandRateCSV(this.properties);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', `Land_Rates_Page_${this.currentPage}_${moment().format('YYYY-MM-DD_HHmmss')}.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        alert(`Successfully downloaded ${this.properties.length} records from current page`);
      } catch (error) {
        console.error('Download error:', error);
        alert('Failed to download data: ' + error.message);
      }
    },

    /**
     * Generate CSV from land rate data array
     */
    generateLandRateCSV(data) {
      if (!data || data.length === 0) return '';

      const headers = [
        'NO.',
        'UPN',
        'LR Number',
        'Owner Names',
        'Phone Number',
        'Email',
        'Physical Address',
        'Parcel Size (Ha)',
        'Sub County',
        'Ward',
        'Zone',
        'Block',
        'Land Use',
        'Annual Land Rates',
        'Annual Ground Rent',
        'Total Annual Charges',
        'Land Rates Arrears',
        'Ground Rent Arrears',
        'Total Outstanding Arrears',
        'Accumulated Penalty',
        'Accumulated Interest',
        'Total Payments',
        'Current Balance',
        'Status',
        'Created By',
        'Created By ID',
        'Date Created'
      ];

      let csv = headers.join(',') + '\n';

      data.forEach((item, index) => {
        const row = [
          index + 1,
          this.escapeCSV(item.UPN),
          this.escapeCSV(item.LRNumber),
          this.escapeCSV(item.ownerNames),
          this.escapeCSV(item.ownerPhoneNo),
          this.escapeCSV(item.ownerEmail),
          this.escapeCSV(item.percelAddress),
          item.percelSize || 0,
          this.escapeCSV(item.subCountyName),
          this.escapeCSV(item.wardName),
          this.escapeCSV(item.zone),
          this.escapeCSV(item.block),
          this.escapeCSV(item.useName),
          parseFloat(item.annualLandRates) || 0,
          parseFloat(item.annualGroundRent) || 0,
          parseFloat(item.annualCharges) || 0,
          parseFloat(item.landRatesArrears) || 0,
          parseFloat(item.groundRentArrears) || 0,
          parseFloat(item.outstandingArrears) || 0,
          parseFloat(item.accumPenalty) || 0,
          parseFloat(item.accumInterest) || 0,
          parseFloat(item.payments) || 0,
          parseFloat(item.currentBalance) || 0,
          this.escapeCSV(item.status || 'Active'),
          this.escapeCSV(item.createdBy),
          this.escapeCSV(item.createdByIDNo),
          this.escapeCSV(this.formatDate(item.dateCreated))
        ];
        csv += row.join(',') + '\n';
      });

      return csv;
    },

    /**
     * Escape CSV values
     */
    escapeCSV(value) {
      if (value === null || value === undefined) return '';
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return '"' + stringValue.replace(/"/g, '""') + '"';
      }
      return stringValue;
    },

    /**
     * Get Success Rate
     */
    getSuccessRate() {
      if (this.downloadProgress.total === 0) return 100;
      const successfulPages = this.downloadProgress.current - this.downloadRetryCount;
      return Math.round((successfulPages / this.downloadProgress.total) * 100);
    },

    /**
     * Pause Download
     */
    pauseDownload() {
      this.downloadPaused = true;
      console.log('Download paused at page:', this.downloadState.currentPage);
    },

    /**
     * Resume Download
     */
    async resumeDownload() {
      this.downloadPaused = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;

      console.log('Resuming download from page:', this.downloadState.currentPage + 1);
      await this.continueDownload();
    },
    openBillingModal(item) {
      this.selectPlot(item, '');
      this.$nextTick(() => {
        const modal = document.querySelector('.plot-billing-modal') || document.querySelector('#bill-client');
        if (modal) {
          const modalInstance = new bootstrap.Modal(modal);
          modalInstance.show();
        } else {
          console.error('Billing modal not found');
        }
      });
    },

    /**
     * Cancel Download
     */
    cancelDownload() {
      const confirmed = confirm('Are you sure you want to cancel the download? All progress will be lost.');

      if (confirmed) {
        this.downloadCancelled = true;
        this.closeDownloadModal();
      }
    },

    /**
     * Close Download Modal
     */
    closeDownloadModal() {
      const modalElement = document.getElementById('downloadProgressModal');
      if (modalElement) {
        const existingModal = bootstrap.Modal.getInstance(modalElement);
        if (existingModal) {
          existingModal.hide();
        }
      }

      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      this.isDownloadingAll = false;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allRecordsData = [];
      this.downloadProgress = {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      };
      this.downloadState = {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      };
    },

    /**
     * Download All Records with Pause/Resume/Retry and Time Estimation
     */
    async downloadAllRecords() {
      if (this.summary.count === 0) {
        alert('No records to download');
        return;
      }

      const isConfirmed = confirm(
          `You are about to download all ${this.numberFormat(this.summary.count)} land rate records. This may take several minutes. Do you want to continue?`
      );

      if (!isConfirmed) return;

      this.isDownloadingAll = true;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allRecordsData = [];

      const batchSize = 1000;
      const totalRecords = this.summary.count;
      const totalPages = Math.ceil(totalRecords / batchSize);

      this.downloadState = {
        startPage: 1,
        currentPage: 0,
        batchSize: batchSize,
        totalPages: totalPages,
        accumulatedData: []
      };

      this.downloadProgress = {
        current: 0,
        total: totalPages,
        percentage: 0,
        records: 0,
        totalRecords: totalRecords,
        startTime: Date.now(),
        estimatedTimeRemaining: null,
        averageSpeed: 0
      };

      const modalElement = document.getElementById('downloadProgressModal');
      const progressModal = new bootstrap.Modal(modalElement);
      progressModal.show();

      await this.continueDownload();
    },

    /**
     * Continue Download (used by both initial download and resume)
     */
    async continueDownload() {
      try {
        const startPage = this.downloadState.currentPage + 1;
        const totalPages = this.downloadState.totalPages;

        for (let page = startPage; page <= totalPages; page++) {
          if (this.downloadPaused) {
            console.log('Download paused, waiting for resume...');
            return;
          }

          if (this.downloadCancelled) {
            console.log('Download cancelled by user');
            return;
          }

          try {
            this.downloadState.currentPage = page;
            this.downloadProgress.current = page;
            this.downloadProgress.percentage = Math.round((page / totalPages) * 100);

            const pageData = await this.fetchLandRatesPageWithRetry(page, this.downloadState.batchSize);

            if (pageData && pageData.length > 0) {
              this.downloadState.accumulatedData = [...this.downloadState.accumulatedData, ...pageData];
              this.allRecordsData = this.downloadState.accumulatedData;
              this.downloadProgress.records = this.allRecordsData.length;

              this.calculateEstimatedTime();
            }

            this.downloadRetryCount = 0;
            this.downloadError = null;

            await this.delay(50);

          } catch (error) {
            console.error(`Error fetching page ${page}:`, error);
            this.downloadError = error.message;
            this.downloadPaused = true;
            return;
          }
        }

        await this.finalizeDownload();

      } catch (error) {
        console.error('Download error:', error);
        this.downloadError = error.message;
        this.downloadPaused = true;
      }
    },

    /**
     * Fetch Land Rates Page with Retry Logic
     */
    async fetchLandRatesPageWithRetry(page, rowsPerPage, retryCount = 0) {
      try {
        const data = new FormData();
        data.append("function", "getLandRates");
        data.append("page", page);
        data.append("rows_per_page", rowsPerPage);
        data.append("search", this.keyword || '');
        data.append("subCountyName", this.subCountyName || '');
        data.append("wardName", this.wardName || '');
        data.append("dateFrom", this.dateFrom || '');
        data.append("dateTo", this.dateTo || '');

        const res = await execute(data, landRate);

        if (res.data.success && res.data.data && res.data.data.properties) {
          return res.data.data.properties;
        } else {
          throw new Error(res.data.message || 'Failed to fetch data');
        }
      } catch (error) {
        if (retryCount < this.maxRetries) {
          this.downloadRetryCount = retryCount + 1;
          console.log(`Retry ${this.downloadRetryCount} for page ${page}`);
          await this.delay(2000);
          return this.fetchLandRatesPageWithRetry(page, rowsPerPage, retryCount + 1);
        } else {
          throw new Error(`Failed to fetch page ${page} after ${this.maxRetries} retries: ${error.message}`);
        }
      }
    },

    /**
     * Delay helper function
     */
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    /**
     * Finalize Download - Generate and download CSV
     */
    async finalizeDownload() {
      try {
        const csv = this.generateLandRateCSV(this.allRecordsData);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        const fileName = `Land_Rates_All_Records_${moment().format('YYYY-MM-DD_HHmmss')}.csv`;

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);

        alert(`Successfully downloaded ${this.numberFormat(this.allRecordsData.length)} land rate records!`);

        this.closeDownloadModal();

      } catch (error) {
        console.error('Error finalizing download:', error);
        this.downloadError = 'Error creating CSV file: ' + error.message;
        this.downloadPaused = true;
      }
    },

    openBulkModal() {
      this.$refs.bulkModal.openModal();
    },

    // =============================================
    // PENALTY MANAGEMENT METHODS
    // =============================================

    /**
     * Calculate 3% monthly interest on landrate arrears (per BRD requirements)
     */
    calculateMonthlyInterest() {
      if (this.processingInterest) {
        alert("Interest calculation is already in progress. Please wait for it to complete.");
        return;
      }

      if (!window.confirm("Calculate 3% monthly interest on all properties with landrate arrears?\n\nThis will apply interest as per  County Finance Act 2019.\n\nNote: Properties already processed this month will be automatically skipped.")) {
        return;
      }

      this.processingInterest = true;
      this.processingStatus = {
        title: "Calculating Monthly Interest",
        message: "Applying 3% monthly interest on landrate arrears (excluding already processed properties)..."
      };

      const data = new FormData();
      data.append("function", "calculateMonthlyInterest");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      data.append("processingMonth", new Date().getMonth() + 1);
      data.append("processingYear", new Date().getFullYear());

      execute(data, landRate)
          .then((res) => {
            this.processingInterest = false;
            this.processingStatus = null;

            if (res.data.success) {
              const summary = res.data.data.summary;
              this.lastProcessingSummary.interest = summary;

              let message = `Monthly Interest Calculation Completed!\n\n`;
              message += `Properties Processed: ${summary.propertiesProcessed}\n`;
              message += `Total Interest Applied: KES ${this.numberFormat(summary.totalInterestApplied)}\n`;
              message += `Errors: ${summary.errorCount}`;

              if (summary.propertiesProcessed === 0) {
                message += `\n\nNote: No new properties found for processing. All eligible properties may have already been processed this month.`;
              }

              alert(message);
              this.getLandRates();
            } else {
              alert("Error calculating monthly interest: " + res.data.message);
            }
          })
          .catch((e) => {
            this.processingInterest = false;
            this.processingStatus = null;
            alert("Error: " + e.message);
          });
    },

    /**
     * Calculate 25% annual penalty on ground rent arrears (per BRD requirements)
     */
    calculateAnnualRentPenalty() {
      if (this.processingPenalty) {
        alert("Penalty calculation is already in progress. Please wait for it to complete.");
        return;
      }

      if (!window.confirm("Calculate 25% annual penalty on all properties with ground rent arrears?\n\nThis will apply penalties as per BRD requirements.\n\nNote: Properties already processed this fiscal year will be automatically skipped.")) {
        return;
      }

      this.processingPenalty = true;
      this.processingStatus = {
        title: "Calculating Annual Rent Penalty",
        message: "Applying 25% annual penalty on ground rent arrears (excluding already processed properties)..."
      };

      const data = new FormData();
      data.append("function", "calculateAnnualRentPenalty");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      data.append("fiscalYear", new Date().getFullYear().toString());

      execute(data, landRate)
          .then((res) => {
            this.processingPenalty = false;
            this.processingStatus = null;

            if (res.data.success) {
              const summary = res.data.data.summary;
              this.lastProcessingSummary.penalty = summary;

              let message = `Annual Rent Penalty Calculation Completed!\n\n`;
              message += `Properties Processed: ${summary.propertiesProcessed}\n`;
              message += `Total Penalties Applied: KES ${this.numberFormat(summary.totalPenaltyApplied)}\n`;
              message += `Errors: ${summary.errorCount}`;

              if (summary.propertiesProcessed === 0) {
                message += `\n\nNote: No new properties found for processing. All eligible properties may have already been processed this fiscal year.`;
              }

              alert(message);
              this.getLandRates();
            } else {
              alert("Error calculating annual penalty: " + res.data.message);
            }
          })
          .catch((e) => {
            this.processingPenalty = false;
            this.processingStatus = null;
            alert("Error: " + e.message);
          });
    },

    /**
     * Select property for payment processing
     */
    selectPlotForPayment(property) {
      this.selectedPropertyForPayment = property;
      this.paymentForm = {
        amount: property.currentBalance || 0,
        paymentMode: '',
        transactionCode: '',
        paidBy: property.ownerNames || '',
        phoneNumber: property.ownerPhoneNo || ''
      };
    },

    /**
     * Process payment using BRD priority logic (Interest → Penalty → Principal)
     */
    processPayment() {
      if (!this.paymentForm.amount || this.paymentForm.amount <= 0) {
        alert("Please enter a valid payment amount");
        return;
      }

      if (!this.paymentForm.paymentMode) {
        alert("Please select payment mode");
        return;
      }

      if (!this.selectedPropertyForPayment) {
        alert("No property selected for payment");
        return;
      }

      const confirmMessage = `Confirm payment processing:\n\nProperty: ${this.selectedPropertyForPayment.LRNumber}\nAmount: KES ${this.numberFormat(this.paymentForm.amount)}\nPayment Mode: ${this.paymentForm.paymentMode}\n\nPayment will be allocated using BRD priority:\n1. Interest → 2. Penalty → 3. Land Rates → 4. Ground Rent`;

      if (!window.confirm(confirmMessage)) {
        return;
      }

      this.processingPayment = true;

      const data = new FormData();
      data.append("function", "applyPayment");
      data.append("LRNumber", this.selectedPropertyForPayment.LRNumber);
      data.append("paymentAmount", this.paymentForm.amount.toString());
      data.append("paymentMode", this.paymentForm.paymentMode);
      data.append("transactionCode", this.paymentForm.transactionCode || '');
      data.append("paidBy", this.paymentForm.paidBy || '');
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, landRate)
          .then((res) => {
            this.processingPayment = false;

            if (res.data.success) {
              const summary = res.data.data.paymentSummary;

              let allocationDetails = `Payment Allocation:\n`;
              allocationDetails += `• Interest Paid: KES ${this.numberFormat(summary.interestPaid)}\n`;
              allocationDetails += `• Penalty Paid: KES ${this.numberFormat(summary.penaltyPaid)}\n`;
              allocationDetails += `• Land Rates Paid: KES ${this.numberFormat(summary.landRatesPaid)}\n`;
              allocationDetails += `• Ground Rent Paid: KES ${this.numberFormat(summary.groundRentPaid)}\n`;
              allocationDetails += `\nRemaining Balance: KES ${this.numberFormat(summary.remainingBalance)}`;

              if (summary.excessPayment > 0) {
                allocationDetails += `\nExcess Payment: KES ${this.numberFormat(summary.excessPayment)}`;
              }

              alert(`Payment Processed Successfully!\n\n${allocationDetails}`);

              const modal = document.querySelector('.payment-processing-modal');
              if (modal) {
                const modalInstance = bootstrap.Modal.getInstance(modal);
                if (modalInstance) {
                  modalInstance.hide();
                }
              }

              this.getLandRates();
              this.selectedPropertyForPayment = null;
              this.paymentForm = { amount: 0, paymentMode: '', transactionCode: '', paidBy: '', phoneNumber: '' };

            } else {
              alert("Payment processing failed: " + res.data.message);
            }
          })
          .catch((e) => {
            this.processingPayment = false;
            alert("Payment processing error: " + e.message);
          });
    },

    /**
     * Generate arrears report by geographic levels (per BRD requirements)
     */
    generateArrearsReport() {
      this.loadingArrearsReport = true;
      this.arrearsReportData = null;
      this.arrearsReportTotals = null;

      const data = new FormData();
      data.append("function", "getArrearsReport");
      data.append("reportType", this.arrearsReportForm.reportType);
      data.append("subCountyName", this.arrearsReportForm.subCountyName);
      data.append("wardName", this.arrearsReportForm.wardName);
      data.append("zone", this.arrearsReportForm.zone);

      execute(data, landRate)
          .then((res) => {
            this.loadingArrearsReport = false;

            if (res.data.success) {
              this.arrearsReportData = res.data.data.arrearsReport;
              this.arrearsReportTotals = res.data.data.totals;
            } else {
              alert("Error generating arrears report: " + res.data.message);
            }
          })
          .catch((e) => {
            this.loadingArrearsReport = false;
            alert("Error: " + e.message);
          });
    },

    /**
     * Download arrears report as CSV
     */
    downloadArrearsReport() {
      if (!this.arrearsReportData || this.arrearsReportData.length === 0) {
        alert("No data to download");
        return;
      }

      try {
        const headers = [
          'Location',
          'Total Properties',
          'Land Rates Arrears',
          'Ground Rent Arrears',
          'Interest',
          'Penalty',
          'Total Arrears'
        ];

        const csvData = this.arrearsReportData.map(item => [
          item.location || '',
          item.totalProperties || 0,
          parseFloat(item.totalLandRatesArrears) || 0,
          parseFloat(item.totalGroundRentArrears) || 0,
          parseFloat(item.totalInterest) || 0,
          parseFloat(item.totalPenalty) || 0,
          parseFloat(item.totalArrears) || 0
        ]);

        if (this.arrearsReportTotals) {
          csvData.push([
            'GRAND TOTAL',
            this.arrearsReportTotals.totalProperties || 0,
            parseFloat(this.arrearsReportTotals.grandTotalLandRates) || 0,
            parseFloat(this.arrearsReportTotals.grandTotalGroundRent) || 0,
            parseFloat(this.arrearsReportTotals.grandTotalInterest) || 0,
            parseFloat(this.arrearsReportTotals.grandTotalPenalty) || 0,
            parseFloat(this.arrearsReportTotals.grandTotalArrears) || 0
          ]);
        }

        const csvContent = this.convertToCSV([headers, ...csvData]);
        const fileName = `Arrears_Report_${this.arrearsReportForm.reportType}_${new Date().toISOString().slice(0, 10)}.csv`;

        this.downloadCSVFile(csvContent, fileName);

      } catch (error) {
        console.error('Download error:', error);
        alert('Error generating CSV file. Please try again.');
      }
    },

    closeAllModals() {
      const modals = document.querySelectorAll('.modal.show');
      modals.forEach(modal => {
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) {
          modalInstance.hide();
        }
      });
    },

    openAmalgamationHistory(item) {
      this.selectPlot(item, '');
      this.$nextTick(() => {
        const amalgamationHistoryComponent = this.$refs.amalgamationHistory;
        if (amalgamationHistoryComponent) {
          amalgamationHistoryComponent.openModal();
        }
      });
    },

    viewProperty(propertyId) {
      const data = new FormData();
      data.append("function", "getProperty");
      data.append("id", propertyId);
      execute(data, landRate)
          .then((res) => {
            if (res.data.success) {
              this.property = res.data.data.property;
              document.querySelector('.details-modal').classList.add('show');
              document.querySelector('.details-modal').style.display = 'block';
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    menuAccess(){
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Land Rate");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then((res) => {
          })
          .catch((e) => {
          });
    },

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getLandRates()
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getLandRates()
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getLandRates()
      }
    },

    formatDate(date) {
      let d = new Date(date);
      let day = d.getDate();
      let month = d.toLocaleString('en-US', { month: 'short' });
      let year = d.getFullYear();

      let suffix = '';
      if (day % 10 === 1 && day !== 11) {
        suffix = 'st';
      } else if (day % 10 === 2 && day !== 12) {
        suffix = 'nd';
      } else if (day % 10 === 3 && day !== 13) {
        suffix = 'rd';
      } else {
        suffix = 'th';
      }
      return `${day}${suffix} ${month} ${year}`;
    },

    formattedTime(time) {
      return moment(time).format('hh:mm A')
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num)
    },

    getSubCounties(){
      const data = new FormData();
      data.append("function", "getSubCounty");
      execute(data,biller)
          .then((res) =>{
            if (res.data.success) {
              this.subCounties =res.data.data.subCounties
              this.subCounties.forEach((value, index) => {
                if (this.property.subCountyID === value.subCountyID) {
                  this.subCounty = this.subCounties[index];
                  this.getWards()
                }
              });
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },

    changeTitle(){
      this.title ="ADD NEW PLOT"
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') {
        return input;
      }
      const digits = input.replace(/\D/g, '');
      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }
      return input;
    },

    getWards(subCountyID = null){
      this.wards =[]
      this.ward = ''
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", subCountyID || this.subCounty.subCountyID);
      execute(data,biller)
          .then((res) =>{
            if (res.data.success) {
              this.wards =res.data.data.wards
              this.wards.forEach((value, index) => {
                if (this.property.wardID === value.wardID) {
                  this.ward = this.wards[index];
                }
              });
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },

    selectedIncomeType(incomeType){
      this.getFeesAndChargesBilling(incomeType.incomeTypeId)
    },

    getIncomeTypes(){
      this.message =null
      this.billingModule.incomeTypes.splice(0)
      this.feesAndCharges.splice(0)
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", "LANDRATE");
      data.append("keyword", "Land Rate");
      execute(data,biller)
          .then((res) =>{
            if (res.data.success) {
              this.billingModule.incomeTypes =res.data.data.incomeTypes
              this.getFeesAndChargesBilling(this.billingModule.incomeTypes[0].incomeTypeId)
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },

    getFeesAndChargesBilling(incomeTypeId){
      this.message =null
      this.feesAndCharges.splice(0)
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId",incomeTypeId);
      execute(data,biller)
          .then((res) =>{
            if (res.data.success) {
              this.feesAndCharges = res.data.data.feesAndCharges
              this.selectedFeeAndChargeFirstOne()
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },

    selectedFeeAndCharge(feeData){
      this.amount = feeData.unitFeeAmount
      this.feeID = feeData.feeId
      this.unitFeeAmount = feeData.unitFeeAmount
      this.feesAndChargeItems = []
      this.feesAndChargeItems.splice(0)
      this.feesAndChargeItems.push(feeData)
    },

    selectedFeeAndChargeFirstOne(){
      const data = this.feesAndCharges[0]
      this.amount = data.unitFeeAmount
      this.feeID = data.feeId
      this.unitFeeAmount = data.unitFeeAmount
      this.feesAndChargeItems = []
      this.feesAndChargeItems.splice(0)
      this.feesAndChargeItems.push(data)
    },

    selectProperty(item) {
      console.log("Selected property for subdivision history:", item);
      this.property = item;
    },

    goToPropertyStatement(property) {
      // Store property data in sessionStorage
      sessionStorage.setItem("statementPropertyId", property.id);
      sessionStorage.setItem("statementLRNumber", property.LRNumber);
      sessionStorage.setItem("statementOwnerNames", property.ownerNames);

      // Navigate to the property statement page
      this.$router.push('/property-statement');
    },

    selectPlot(property,title){
      this.isSelectingPlot = true  // Set flag before
      this.title =title
      this.property = property
      this.selectedProperties.splice(0)
      this.totalAmount =0
      this.feesAndChargeItems.splice(0)
      this.selectedProperties.push(property)
      this.billItem.splice(0)
      this.getSubCounties()
        setTimeout(() => {
        this.isSelectingPlot = false
      }, 500)
    },

    deleteLandRate(plot) {
      this.property = plot;
      if (window.confirm("Are you sure you want to delete  '" + this.property.LRNumber + "'?")) {
        const data = new FormData();
        data.append("function", "deleteLandRate");
        data.append("id", this.property.id);
        data.append("property", JSON.stringify(this.property));
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
        data.append("sessionPhoneNumber", sessionStorage.getItem("sessionPhoneNumber"));
        execute(data,landRate)
            .then((res) =>{
              if (res.data.success) {
                this.getLandRates()
              }else{
                this.message =res.data.message
              }
            })
            .catch((e) => {
              this.message =e.message
            });
      }
    },

    openEditModal(property) {
      this.propertyToEdit = { ...property };
      if (property.subCountyID) {
        this.getWards(property.subCountyID);
      }
    },

    handlePropertyUpdated() {
      this.getLandRates();
    },

    handleAddBlock(blockData) {
      if (window.confirm("Are you sure you want to add?")) {
        const data = new FormData();
        data.append("function", "addBlock");
        data.append("block", blockData.block);
        data.append("subCountyID", blockData.subCounty.subCountyID);
        data.append("subCountyName", blockData.subCounty.subCountyName);
        data.append("wardID", blockData.ward.wardID);
        data.append("wardName", blockData.ward.wardName);
        execute(data,landRate)
            .then((res) =>{
              if (res.data.success) {
                this.getBlocks()
              }else{
                this.message =res.data.message
              }
            })
            .catch((e) => {
              this.message =e.message
            });
      }
    },

    getBlocks() {
      this.blocks.splice(0)
      const data = new FormData();
      data.append("function", "getBlocks");
      execute(data, landRate)
          .then((res) => {
            this.loading = false
            if (res.data.success) {
              this.blocks = res.data.data.blocks
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getUses() {
      this.uses.splice(0)
      const data = new FormData();
      data.append("function", "getUses");
      execute(data, landRate)
          .then((res) => {
            this.loading = false
            if (res.data.success) {
              this.uses = res.data.data.uses
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getLandRates() {
      this.loading = true
      this.properties.splice(0)
      const data = new FormData();
      data.append("function", "getLandRates");
      data.append("search", this.keyword !== undefined ? this.keyword : "");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("subCountyName", this.subCountyName !== null && this.subCountyName !== undefined ? this.subCountyName : "");
      data.append("wardName", this.wardName !== null && this.wardName !== undefined ? this.wardName : "");
      execute(data, landRate)
          .then((res) => {
            this.loading = false
            if (res.data.success) {
              this.properties = res.data.data.properties
              this.summary = res.data.data.count.count
              this.totalItems = res.data.data.count.count
              this.totalPages = Math.ceil(this.totalItems / this.pageSize);

              this.totalAnnual = this.properties.reduce((acc, cur) => {
                let totalAmount = Number(cur.annualCharges);
                return acc + totalAmount;
              }, 0);

              this.totalBalance = this.properties.reduce((acc, cur) => {
                let totalAmount = Number(cur.currentBalance) || Number(cur.outstandingArrears);
                return acc + totalAmount;
              }, 0);

              this.totalArrears = this.properties.reduce((acc, cur) => {
                let totalAmount = Number(cur.outstandingArrears);
                return acc + totalAmount;
              }, 0);
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    handleAddPlot(propertyData) {
      propertyData.createdBy = sessionStorage.getItem("sessionNames")
      propertyData.createdByIDNo = sessionStorage.getItem("sessionIdNo")
      const data = {
        ...propertyData,
        function: "addLandRates"
      };

      executeJson(data, landRate)
          .then((res) => {
            if (res.data.success) {
              alert(res.data.message)
              this.getLandRates()
              this.title ="Add New Property"
            } else {
              this.message = res.data.message
              alert(res.data.message)
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getRight(type){
      return getRight(type)
    },

    generateFeeAndChargesItem() {
      this.billItem.splice(0);

      for (let item of this.selectedProperties) {
        let newItem = {
          feeId: this.feeID,
          unitFeeAmount: this.amount,
          customer: item.id,  // CHANGED: Use Property ID instead of LRNumber
          customerPhoneNumber: this.property.ownerPhoneNo
        };
        this.feesAndChargeItems.splice(0);
        this.feesAndChargeItems.push(newItem);
      }
      this.addToBill();
    },

    addToBill(){
      for (const { typeDescription,feeId, feeDescription, unitFeeAmount, accountNo, costCenterNo, incomeTypeId, customer} of this.feesAndChargeItems) {
        this.totalAmount += parseFloat(unitFeeAmount);
        this.billItem.push({
          typeDescription,
          feeDescription,
          unitFeeAmount: unitFeeAmount,
          accountNo,
          costCenterNo,
          incomeTypeId,
          revenueStreamItem: this.property.id,  // CHANGED: Use Property ID
          feeId,
          amount: unitFeeAmount,
          customer: this.property.id,  // CHANGED: Use Property ID instead of customer variable
          zone: this.property.zone,
          subCountyID: this.property.subCountyID,
          subCountyName: this.property.subCountyName,
          wardID: this.property.wardID,
          wardName: this.property.wardName,
          idNo: sessionStorage.getItem("sessionIdNo"),
          phoneNumber: sessionStorage.getItem("sessionPhoneNumber"),
          names: sessionStorage.getItem("sessionNames"),
          customerPhoneNumber: this.property.ownerPhoneNo,
          // Description with Property ID as first identifier
          description: `Property ID: ${this.property.id} | UPN NO.: ${this.property.UPN || ''} | Block No.: ${this.property.block || ''} | Plot No.: ${this.property.LRNumber} | Address: ${this.property.percelAddress || ''} | Name: ${this.property.ownerNames} | CHARGES - Annual Rate: KES ${this.numberFormat(this.property.annualCharges)}, Outstanding Arrears: KES ${this.numberFormat(this.property.outstandingArrears)}, Current Balance: KES ${this.numberFormat(this.property.currentBalance || this.property.outstandingArrears)}`,
          customerName: `${this.property.LRNumber} | ${this.property.ownerNames}`  // Keep LRNumber here for display purposes
        });
      }
    },

    generateDemandBill(){
      this.demandNotice = false
      this.generateBillLoading = true
      this.amount = this.property.outstandingArrears || this.property.currentBalance

      this.generateFeeAndChargesItem()

      this.paymentMethod = false;
      this.paymentPanel = true;
      this.transactionSummary = false ;
      this.transactionCompleted = false
      this.message ="Generating Bill...please wait... "
      const data = new FormData();
      data.append("function", "generateBill3");
      data.append("billItem", JSON.stringify(this.billItem));
      data.append("customerPhoneNumber", this.property.ownerPhoneNo);
      data.append("messageCode","DEMAND-NOTICE");
      data.append("names",this.property.ownerNames);
      data.append("email",this.property.ownerEmail);
      execute(data,biller)
          .then((res) =>{
            this.demandNotice = true
            this.message =res.data.message
            if (res.data.success) {
              this.billDetails = res.data.data.bill.billDetails
              this.billInfo = res.data.data.bill.billInfo
              this.paymentData.amount = res.data.data.bill.billDetails.billBalance
              this.paymentData.accNo = res.data.data.bill.billDetails.billNo
              this.paymentData.payBillNo = res.data.data.billGenerated.payBillNo

              this.paymentData.sessionNames =sessionStorage.getItem("sessionNames")
              this.paymentData.sessionIdNo =sessionStorage.getItem("sessionIdNo")
              this.paymentData.sessionPhoneNumber = sessionStorage.getItem("sessionPhoneNumber")
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },

    generateBill(billingData) {
      this.amount = billingData.invoiceAmount;
      this.selectedIncomeType = billingData.selectedIncomeType;
      this.selectedFeeType = billingData.selectedFeeType;

      this.generateFeeAndChargesItem();

      this.paymentMethod = false;
      this.paymentPanel = true;
      this.transactionSummary = false;
      this.transactionCompleted = false;
      this.message = "Generating Bill...please wait...";

      const data = new FormData();
      data.append("function", "generateBill3");
      data.append("billItem", JSON.stringify(this.billItem));
      data.append("customerPhoneNumber", this.property.ownerPhoneNo);
      data.append("messageCode", "BLL");
      data.append("names", this.property.ownerNames);
      data.append("email", this.property.ownerEmail);

      execute(data, biller)
          .then((res) => {
            this.message = res.data.message;
            if (res.data.success) {
              this.billDetails = res.data.data.bill.billDetails;
              this.billInfo = res.data.data.bill.billInfo;
              this.paymentData.amount = res.data.data.bill.billDetails.billBalance;
              this.paymentData.accNo = res.data.data.bill.billDetails.billNo;
              this.paymentData.payBillNo = res.data.data.billGenerated.payBillNo;

              this.paymentData.sessionNames = sessionStorage.getItem("sessionNames");
              this.paymentData.sessionIdNo = sessionStorage.getItem("sessionIdNo");
              this.paymentData.sessionPhoneNumber = sessionStorage.getItem("sessionPhoneNumber");

              this.$refs.billingModal?.forceCloseModal();
              this.closeBillingModal();

              setTimeout(() => {
                this.openPaymentModal();
              }, 300);

            } else {
              this.message = res.data.message;
              alert(res.data.message);
            }
          })
          .catch((e) => {
            this.message = e.message;
            alert("Error generating bill: " + e.message);
          });
    },

    closeBillingModal() {
      try {
        const billingModal = document.querySelector('#bill-client');
        if (billingModal) {
          const modalInstance = bootstrap.Modal.getInstance(billingModal);
          if (modalInstance) {
            modalInstance.hide();
          } else {
            const newModalInstance = new bootstrap.Modal(billingModal);
            newModalInstance.hide();
          }
        }

        const modalElement = document.querySelector('.add-plot-modal.show') ||
            document.querySelector('#bill-client.show');
        if (modalElement) {
          modalElement.classList.remove('show');
          modalElement.style.display = 'none';

          const backdrop = document.querySelector('.modal-backdrop');
          if (backdrop) {
            backdrop.remove();
          }

          document.body.classList.remove('modal-open');
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
        }
      } catch (error) {
        console.error('Error closing billing modal:', error);
      }
    },

    openPaymentModal() {
      try {
        const paymentModal = document.querySelector('#payment-modal');
        if (paymentModal) {
          const modalInstance = new bootstrap.Modal(paymentModal, {
            backdrop: 'static',
            keyboard: false
          });
          modalInstance.show();
        }
      } catch (error) {
        console.error('Error opening payment modal:', error);
      }
    },

    printDemandNotice() {
      localStorage['params'] = JSON.stringify({
        propertyId: this.property.id
      });

      const routeData = this.$router.resolve({name: 'demand-notice'});
      window.open(routeData.href, '_blank');

      const modal = document.querySelector('#demandNotice');
      if (modal) {
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) {
          modalInstance.hide();
        }
      }
    },

    printBillDemandNotice() {
      localStorage['params'] = JSON.stringify({
        propertyId: this.property.id
      });

      const routeData = this.$router.resolve({name: 'demand-notice'});
      window.open(routeData.href, '_blank');
    },

    printBill() {
      localStorage['params'] = JSON.stringify({
        billNo: this.billDetails.billNo
      })
      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },

    printReceipt() {
      if (this.receiptDetails.receiptNo == null) {
        alert("Try again later");
      } else {
        localStorage['params'] = JSON.stringify({
          receiptNo: this.receiptDetails.receiptNo
        })
        const routeData = this.$router.resolve({name: 'receipt'});
        window.open(routeData.href, '_blank');
      }
    },

    showPaymentMethod() {
      this.paymentMethod = true;
      this.paymentPanel = false;
      this.transactionSummary = false;
      this.transactionCompleted = false;
    },

    showTransactionSummary(paymentData) {
      this.paymentData.paymentMode = paymentData.paymentMode;
      this.phoneNumber = paymentData.phoneNumber;
      this.paymentData.bankReceiptNo = paymentData.bankReceiptNo;

      this.paymentMethod = false;
      this.paymentPanel = false;
      this.transactionSummary = true;
      this.transactionCompleted = false;
    },

    makePayment(paymentInfo) {
      this.message = "Payment Request sent";
      this.paymentData.phoneNumber = paymentInfo.phoneNumber
      this.paymentData.paymentMode = paymentInfo.paymentMode
      this.paymentData.bankReceiptNo = paymentInfo.bankReceiptNo

      const data = new FormData();
      data.append("function", "makePayment");
      data.append("paymentData", JSON.stringify(this.paymentData));

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.paymentMethod = false;
              this.paymentPanel = false;
              this.timer = setInterval(() => {
                this.checkPayment();
              }, 3000);
            } else {
              this.rate = null;
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    checkPayment() {
      this.randomNumber = Math.floor(Math.random() * 3) + 1
      if(this.randomNumber === 1){
        this.message = "Waiting for payment.";
      }
      if(this.randomNumber === 2){
        this.message = "Waiting for payment..";
      }
      if(this.randomNumber === 3){
        this.message = "Waiting for payment...";
      }
      const data = new FormData();
      data.append("function", "checkPayment");
      data.append("accountRef", this.paymentData.accNo);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.message = null;
              clearInterval(this.timer);
              this.receipt = true;
              this.paymentData.success = false;
              this.transaction = res.data.data.transaction;
              this.receiptDetails = res.data.data.receipt.receiptDetails
              this.transactionSummary = false
              this.transactionCompleted = true
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    formatPrice(value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    },

    gotTo(route,LRNumber,zone){
      sessionStorage.setItem("LRNumber",LRNumber)
      sessionStorage.setItem("zone",zone)
      router.push(route)
    },

    getZones(subCountyID){
      this.message = null
      this.zones.splice(0)
      const data = new FormData();
      data.append("function", "getZones");
      data.append("subCountyID", subCountyID);
      execute(data,authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.zones = res.data.data.zones
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },

    handleUploadPlot(uploadData) {
      if (!uploadData.subCounty || !uploadData.subCounty.subCountyName) {
        alert("Select Sub County")
        return
      }

      if (!uploadData.zone || uploadData.zone.trim() === '' || !uploadData.data || uploadData.data.length === 0) {
        alert("Please ensure zone is selected and valid data is available.")
        return
      }

      const confirmMessage = `
        Ready to upload:
        - ${uploadData.summary.validRows} valid records
        - Zone: ${uploadData.zone}
        - Sub County: ${uploadData.subCounty.subCountyName}

        ${uploadData.summary.invalidRows > 0 ? `Note: ${uploadData.summary.invalidRows} invalid rows will be skipped.` : ''}

        Do you want to proceed?
      `;

      if (!window.confirm(confirmMessage)) {
        return;
      }

      this.loading = true;

      // Note: ...row spread operator includes all fields from Excel including idNo (owner ID number)
      const enhancedData = uploadData.data.map(row => ({
        ...row,  // Includes: upn, plotNo, ownerNames, idNo, ownerPhoneNo, ownerEmail, etc.
        createdBy: sessionStorage.getItem("sessionNames"),
        createdByIDNo: sessionStorage.getItem("sessionIdNo"),
        subCountyID: uploadData.subCounty.subCountyID,
        subCountyName: uploadData.subCounty.subCountyName,
        zone: uploadData.zone,
        status: 'Active',
        dateCreated: new Date().toISOString()
      }));

      const jsonPayload = {
        function: "uploadLandRateData",
        plotData: enhancedData,
        uploadMetadata: {
          zone: uploadData.zone,
          subCountyID: uploadData.subCounty.subCountyID,
          subCountyName: uploadData.subCounty.subCountyName,
          fileName: uploadData.fileName,
          uploadSummary: uploadData.summary,
          uploadedBy: sessionStorage.getItem("sessionNames"),
          uploadedByID: sessionStorage.getItem("sessionIdNo"),
          uploadDate: new Date().toISOString(),
          totalRecords: uploadData.data.length
        }
      };

      executeJson(jsonPayload, landRate)
          .then((res) => {
            this.loading = false;

            if (res.data.success) {
              this.alert.success = true;

              // Store upload results
              this.uploadResult = {
                successful: res.data.data.successful || 0,
                failed: res.data.data.failed || 0,
                totalProcessed: res.data.data.totalProcessed || 0,
                message: res.data.message || 'Upload completed',
                failedRecords: res.data.data.failedRecords || []
              };

              // Show the results modal
              const resultModal = new bootstrap.Modal(document.querySelector('.upload-result-modal'));
              resultModal.show();

              // Refresh the land rates table
              this.getLandRates();

              // Close the upload modal
              const uploadModal = document.querySelector('.upload-plot-modal');
              if (uploadModal) {
                const modalInstance = bootstrap.Modal.getInstance(uploadModal);
                if (modalInstance) {
                  modalInstance.hide();
                }
              }
            } else {
              this.alert.failed = true;
              this.message = res.data.message;

              // Even on failure, show results if available
              if (res.data.data && res.data.data.failedRecords) {
                this.uploadResult = {
                  successful: res.data.data.successful || 0,
                  failed: res.data.data.failed || 0,
                  totalProcessed: res.data.data.totalProcessed || 0,
                  message: res.data.message || 'Upload failed',
                  failedRecords: res.data.data.failedRecords || []
                };

                const resultModal = new bootstrap.Modal(document.querySelector('.upload-result-modal'));
                resultModal.show();
              } else {
                alert(`Upload failed: ${res.data.message}`);
              }
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message;
            alert(`Upload error: ${e.message}`);
            console.error('Upload error:', e);
          });
    },

    // NEW BATCH UPLOAD METHODS
    handleBatchUpload(batchPayload, callback) {
      // Enhance batch data with session info
      const enhancedBatch = batchPayload.plotData.map(row => ({
        ...row,
        createdBy: sessionStorage.getItem("sessionNames"),
        createdByIDNo: sessionStorage.getItem("sessionIdNo"),
        subCountyID: batchPayload.uploadMetadata.subCountyID,
        subCountyName: batchPayload.uploadMetadata.subCountyName,
        zone: batchPayload.uploadMetadata.zone,
        status: 'Active',
        dateCreated: new Date().toISOString()
      }));

      const jsonPayload = {
        function: "uploadLandRateData",
        plotData: enhancedBatch,
        uploadMetadata: batchPayload.uploadMetadata
      };

      executeJson(jsonPayload, landRate)
          .then((res) => {
            if (res.data.success) {
              callback({
                success: true,
                data: {
                  successful: res.data.data.successful || 0,
                  failed: res.data.data.failed || 0,
                  failedRecords: res.data.data.failedRecords || []
                }
              });
            } else {
              callback({
                success: false,
                message: res.data.message,
                data: {
                  successful: 0,
                  failed: enhancedBatch.length,
                  failedRecords: res.data.data?.failedRecords || []
                }
              });
            }
          })
          .catch((e) => {
            console.error('Batch upload error:', e);
            callback({
              success: false,
              message: e.message,
              data: {
                successful: 0,
                failed: enhancedBatch.length,
                failedRecords: []
              }
            });
          });
    },

    handleUploadComplete(finalResults) {
      // Store upload results
      this.uploadResult = {
        successful: finalResults.successful,
        failed: finalResults.failed,
        totalProcessed: finalResults.totalProcessed,
        message: finalResults.message,
        failedRecords: finalResults.failedRecords
      };

      // Show the results modal
      const resultModal = new bootstrap.Modal(document.querySelector('.upload-result-modal'));
      resultModal.show();

      // Refresh the land rates table if any records were uploaded
      if (finalResults.successful > 0) {
        this.getLandRates();
      }

      // Close the upload modal
      const uploadModal = document.querySelector('.upload-plot-modal');
      if (uploadModal) {
        const modalInstance = bootstrap.Modal.getInstance(uploadModal);
        if (modalInstance) {
          modalInstance.hide();
        }
      }
    },

    downloadLandRates(){
      if (this.properties.length === 0) {
        alert("No data to download");
        return;
      }

      this.download = "Preparing...";

      try {
        const headers = [
          'UPN',
          'LR Number',
          'Owner Names',
          'Phone Number',
          'Email',
          'Physical Address',
          'Parcel Size (Ha)',
          'Sub County',
          'Ward',
          'Zone',
          'Block',
          'Land Use',
          'Annual Land Rates',
          'Annual Ground Rent',
          'Total Annual Charges',
          'Land Rates Arrears',
          'Ground Rent Arrears',
          'Total Outstanding Arrears',
          'Accumulated Penalty',
          'Accumulated Interest',
          'Total Payments',
          'Current Balance',
          'Status',
          'Created By',
          'Created By ID',
          'Date Created'
        ];

        const csvData = this.properties.map(item => [
          item.UPN || '',
          item.LRNumber || '',
          item.ownerNames || '',
          item.ownerPhoneNo || '',
          item.ownerEmail || '',
          item.percelAddress || '',
          item.percelSize || 0,
          item.subCountyName || '',
          item.wardName || '',
          item.zone || '',
          item.block || '',
          item.useName || '',
          parseFloat(item.annualLandRates) || 0,
          parseFloat(item.annualGroundRent) || 0,
          parseFloat(item.annualCharges) || 0,
          parseFloat(item.landRatesArrears) || 0,
          parseFloat(item.groundRentArrears) || 0,
          parseFloat(item.outstandingArrears) || 0,
          parseFloat(item.accumPenalty) || 0,
          parseFloat(item.accumInterest) || 0,
          parseFloat(item.payments) || 0,
          parseFloat(item.currentBalance) || 0,
          item.status || 'Active',
          item.createdBy || '',
          item.createdByIDNo || '',
          this.formatDateForCSV(item.dateCreated)
        ]);

        const csvContent = this.convertToCSV([headers, ...csvData]);
        this.downloadCSVFile(csvContent, this.generateFileName());

        this.download = "Download Report";

      } catch (error) {
        console.error('Download error:', error);
        alert('Error generating CSV file. Please try again.');
        this.download = "Download Report";
      }
    },

    convertToCSV(data) {
      return data.map(row =>
          row.map(field => {
            let value = String(field);
            if (value.includes(',') || value.includes('"') || value.includes('\n')) {
              value = `"${value.replace(/"/g, '""')}"`;
            }
            return value;
          }).join(',')
      ).join('\n');
    },

    downloadCSVFile(csvContent, fileName) {
      const blob = new Blob(['\ufeff' + csvContent], {
        type: 'text/csv;charset=utf-8;'
      });

      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    },

    generateFileName() {
      const now = new Date();
      const timestamp = now.toISOString().slice(0, 19).replace(/:/g, '-');

      let fileName = `Land_Rates_Report_${timestamp}`;

      if (this.subCountyName && this.subCountyName !== '') {
        fileName += `_${this.subCountyName.replace(/\s+/g, '_')}`;
      }

      if (this.wardName && this.wardName !== '') {
        fileName += `_${this.wardName.replace(/\s+/g, '_')}`;
      }

      if (this.dateFrom && this.dateTo) {
        fileName += `_${this.dateFrom}_to_${this.dateTo}`;
      }

      return `${fileName}.csv`;
    },

    formatDateForCSV(dateString) {
      if (!dateString) return '';

      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB') + ' ' + date.toLocaleTimeString('en-GB');
      } catch (error) {
        return dateString;
      }
    },

    handleSuspendProperty(property) {
      this.property = property;
    },

    handleReinstateProperty(property) {
      this.property = property;
    },

    handleSetRateStruck(property) {
      this.property = property;
    },

    handleRemoveRateStruck(property) {
      this.property = property;
    },

    confirmSuspendProperty(formData) {
      if (!this.property || !this.property.id) {
        alert("Property data not available. Please try again.");
        return;
      }

      if (formData instanceof FormData) {
        formData.append("function", "suspendProperty");

        execute(formData, landRate)
            .then((res) => {
              if (res.data.success) {
                alert(res.data.message);
                this.getLandRates();
                this.closeModal('.property-suspension-modal');
              } else {
                alert(res.data.message);
              }
            })
            .catch((e) => {
              alert("Error: " + e.message);
            });
      } else {
        const data = new FormData();
        data.append("function", "suspendProperty");
        data.append("propertyID", formData.property.id);
        data.append("LRNumber", formData.property.LRNumber);
        data.append("reason", formData.reason);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

        execute(data, landRate)
            .then((res) => {
              if (res.data.success) {
                alert(res.data.message);
                this.getLandRates();
                this.closeModal('.property-suspension-modal');
              } else {
                alert(res.data.message);
              }
            })
            .catch((e) => {
              alert("Error: " + e.message);
            });
      }
    },

    confirmReinstateProperty(formData) {
      if (!this.property || !this.property.id) {
        alert("Property data not available. Please try again.");
        return;
      }

      if (formData instanceof FormData) {
        formData.append("function", "reinstatementProperty");

        execute(formData, landRate)
            .then((res) => {
              if (res.data.success) {
                alert(res.data.message);
                this.getLandRates();
                this.closeModal('.property-reinstatement-modal');
              } else {
                alert(res.data.message);
              }
            })
            .catch((e) => {
              alert("Error: " + e.message);
            });
      } else {
        const data = new FormData();
        data.append("function", "reinstatementProperty");
        data.append("propertyID", formData.id);
        data.append("LRNumber", formData.LRNumber);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

        execute(data, landRate)
            .then((res) => {
              if (res.data.success) {
                alert(res.data.message);
                this.getLandRates();
                this.closeModal('.property-reinstatement-modal');
              } else {
                alert(res.data.message);
              }
            })
            .catch((e) => {
              alert("Error: " + e.message);
            });
      }
    },

    confirmSetRateStruck(formData) {
      if (!this.property || !this.property.id) {
        alert("Property data not available. Please try again.");
        return;
      }

      if (formData instanceof FormData) {
        formData.append("function", "setRateStruck");

        execute(formData, landRate)
            .then((res) => {
              if (res.data.success) {
                alert(res.data.message);
                this.getLandRates();
                this.closeModal('.rate-struck-modal');
              } else {
                alert(res.data.message);
              }
            })
            .catch((e) => {
              alert("Error: " + e.message);
            });
      } else {
        const data = new FormData();
        data.append("function", "setRateStruck");
        data.append("propertyID", formData.property.id);
        data.append("LRNumber", formData.property.LRNumber);
        data.append("reason", formData.reason);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

        execute(data, landRate)
            .then((res) => {
              if (res.data.success) {
                alert(res.data.message);
                this.getLandRates();
                this.closeModal('.rate-struck-modal');
              } else {
                alert(res.data.message);
              }
            })
            .catch((e) => {
              alert("Error: " + e.message);
            });
      }
    },

    confirmRemoveRateStruck(formData) {
      if (!this.property || !this.property.id) {
        alert("Property data not available. Please try again.");
        return;
      }

      if (formData instanceof FormData) {
        formData.append("function", "removeRateStruck");

        execute(formData, landRate)
            .then((res) => {
              if (res.data.success) {
                alert(res.data.message);
                this.getLandRates();
                this.closeModal('.remove-rate-struck-modal');
              } else {
                alert(res.data.message);
              }
            })
            .catch((e) => {
              alert("Error: " + e.message);
            });
      } else {
        const data = new FormData();
        data.append("function", "removeRateStruck");
        data.append("propertyID", formData.id);
        data.append("LRNumber", formData.LRNumber);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

        execute(data, landRate)
            .then((res) => {
              if (res.data.success) {
                alert(res.data.message);
                this.getLandRates();
                this.closeModal('.remove-rate-struck-modal');
              } else {
                alert(res.data.message);
              }
            })
            .catch((e) => {
              alert("Error: " + e.message);
            });
      }
    },

    closeModal(modalSelector) {
      try {
        const modal = document.querySelector(modalSelector);
        if (modal) {
          const modalInstance = bootstrap.Modal.getInstance(modal);
          if (modalInstance) {
            modalInstance.hide();
          }
        }
      } catch (error) {
        console.error('Error closing modal:', error);
      }
    },

    handleOpenAdjustmentModal(property) {
      this.property = property;
      this.getAdjustmentHistory(property);
    },

    getAdjustmentHistory(property) {
      const data = new FormData();
      data.append("function", "getAdjustmentHistory");
      data.append("propertyID", property.id);
      data.append("LRNumber", property.LRNumber);

      execute(data, landRate)
          .then((res) => {
            if (res.data.success) {
              this.adjustmentHistory = res.data.data.adjustments;
            } else {
              this.adjustmentHistory = [];
            }
          })
          .catch((e) => {
            console.error("Error fetching adjustment history:", e);
            this.adjustmentHistory = [];
          });
    },

    confirmAdjustment(adjustmentData) {
      const data = new FormData();
      data.append("function", "makeAdjustment");
      data.append("propertyID", adjustmentData.property.id);
      data.append("LRNumber", adjustmentData.property.LRNumber);
      data.append("adjustmentType", adjustmentData.adjustmentType);
      data.append("adjustmentAmount", adjustmentData.adjustmentAmount);
      data.append("adjustmentReason", adjustmentData.adjustmentReason);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, landRate)
          .then((res) => {
            if (res.data.success) {
              alert(res.data.message);
              this.getLandRates();
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert("Error: " + e.message);
          });
    },

    handleShowAdjustmentHistory(property) {
      this.property = property;
      this.getAdjustmentHistory(property);
    },

    handleLandUseChange(property) {
      console.log('Method called with property:', property);
      this.selectedPropertyForLandUse = property;
      this.resetLandUseForm();

      setTimeout(() => {
        const modal = document.querySelector('.land-use-change-modal');
        if (modal) {
          const modalInstance = new bootstrap.Modal(modal);
          modalInstance.show();
        } else {
          console.error('Modal element not found');
        }
      }, 100);
    },

    resetLandUseForm() {
      this.landUseChangeStep = 1;
      this.landUseBillNumber = '';
      this.verifiedBill = null;
      this.selectedNewLandUse = null;
      this.landUseChangeReason = '';
      this.landUseError = '';
      this.verifyingBill = false;
      this.submittingLandUseChange = false;
    },

    async verifyBillForLandUse() {
      if (!this.landUseBillNumber.trim()) {
        this.landUseError = 'Please enter a bill number';
        return;
      }

      this.verifyingBill = true;
      this.landUseError = '';

      try {
        const data = new FormData();
        data.append("function", "getBill");
        data.append("billNo", this.landUseBillNumber.trim());

        const response = await execute(data, biller);

        if (response.data.success) {
          const billDetails = response.data.data.billDetails;

          if (billDetails.status !== 'PAID') {
            this.landUseError = `Bill is not paid. Status: ${billDetails.status}. Only paid bills can authorize land use changes.`;
            return;
          }

          this.verifiedBill = billDetails;
          this.landUseChangeStep = 2;

        } else {
          this.landUseError = response.data.message || 'Bill not found';
        }
      } catch (error) {
        this.landUseError = 'Error verifying payment: ' + error.message;
        console.error('Error fetching bill:', error);
      } finally {
        this.verifyingBill = false;
      }
    },

    async submitLandUseChange() {
      if (!this.selectedNewLandUse || !this.landUseChangeReason.trim()) {
        alert('Please select a new land use and provide a reason for the change.');
        return;
      }

      if (!this.selectedPropertyForLandUse || !this.selectedPropertyForLandUse.LRNumber) {
        alert('Property information is not available. Please try again.');
        return;
      }

      const confirmMessage = `Are you sure you want to change the land use for property ${this.selectedPropertyForLandUse.LRNumber}?\n\nFrom: "${this.selectedPropertyForLandUse.useName || 'Not Set'}"\nTo: "${this.selectedNewLandUse.name}"\n\nThis action will be logged and audited.`;

      if (!window.confirm(confirmMessage)) {
        return;
      }

      this.submittingLandUseChange = true;

      try {
        const data = new FormData();
        data.append("function", "updateLandUse");
        data.append("billNo", this.verifiedBill.billNo);
        data.append("propertyId", this.selectedPropertyForLandUse.id);
        data.append("LRNumber", this.selectedPropertyForLandUse.LRNumber);
        data.append("currentLandUse", this.selectedPropertyForLandUse.useName || '');
        data.append("newLandUseId", this.selectedNewLandUse.id);
        data.append("newLandUseName", this.selectedNewLandUse.name);
        data.append("changeReason", this.landUseChangeReason.trim());
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

        const response = await execute(data, landRate);

        if (response.data.success) {
          const successMessage = `Land use successfully changed!\n\nProperty: ${this.selectedPropertyForLandUse.LRNumber}\nFrom: "${this.selectedPropertyForLandUse.useName || 'Not Set'}"\nTo: "${this.selectedNewLandUse.name}"\nAuthorized by: ${this.verifiedBill.billNo}`;

          alert(successMessage);

          const modal = document.querySelector('.land-use-change-modal');
          if (modal) {
            const modalInstance = bootstrap.Modal.getInstance(modal);
            if (modalInstance) {
              modalInstance.hide();
            }
          }

          this.getLandRates();
          this.auditLandUseChange();

        } else {
          alert('Error updating land use: ' + response.data.message);
        }
      } catch (error) {
        alert('Error updating land use: ' + error.message);
        console.error('Error updating land use:', error);
      } finally {
        this.submittingLandUseChange = false;
      }
    },

    auditLandUseChange() {
      const description = `Land use changed from "${this.selectedPropertyForLandUse.useName || 'Not Set'}" to "${this.selectedNewLandUse.name}" for property ${this.selectedPropertyForLandUse.LRNumber} via bill ${this.verifiedBill.billNo}. Reason: ${this.landUseChangeReason}`;

      const data = new FormData();
      data.append("function", "auditAction");
      data.append("action", "LAND_USE_CHANGE");
      data.append("description", description);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, landRate)
          .then((res) => {
            if (res.data.success) {
              console.log('Land use change audit logged successfully');
            }
          })
          .catch((e) => {
            console.error('Audit logging failed:', e);
          });
    }
  }
}
</script>

<style scoped>
.fs-6 {
  font-size: 0.875rem;
}

.small {
  font-size: 0.75rem;
}

.text-end {
  text-align: right;
}

.badge {
  font-size: 0.75em;
}

.table td {
  vertical-align: middle;
}

.table-responsive {
  font-size: 0.9rem;
}

.btn-sm {
  font-size: 0.8rem;
}

/* Enhanced penalty management styles */
.processing-card {
  border-left: 4px solid #28a745;
}

.processing-card.warning {
  border-left-color: #ffc107;
}

.processing-card.danger {
  border-left-color: #dc3545;
}

.penalty-summary {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  transition: all 0.3s ease;
}

.penalty-summary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.admin-tools-card {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
}

.btn-penalty-action {
  transition: all 0.3s ease;
  border-radius: 8px;
}

.btn-penalty-action:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

.modal-penalty .modal-header {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
}

.modal-arrears .modal-header {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
}

/* Payment form enhancements */
.payment-form-section {
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #dee2e6;
}

.payment-priority-info {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-left: 4px solid #2196f3;
}

/* Arrears report table enhancements */
.arrears-table th {
  background: linear-gradient(135deg, #343a40 0%, #495057 100%);
  color: white;
  border: none;
}

.arrears-table td {
  border-bottom: 1px solid #dee2e6;
  vertical-align: middle;
}

.arrears-table tbody tr:hover {
  background-color: #f8f9fa;
}

/* Processing status animations */
.processing-spinner {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

/* Enhanced button states */
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-processing {
  position: relative;
  overflow: hidden;
}

.btn-processing::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

/* Responsive enhancements */
@media (max-width: 768px) {
  .admin-tools-card .row > .col-md-3 {
    margin-bottom: 1rem;
  }

  .penalty-summary {
    margin-bottom: 1rem;
  }

  .btn-penalty-action {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}

/* Table enhancements for better readability */
.table th {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.8rem;
  letter-spacing: 0.5px;
}

.table td {
  font-size: 0.85rem;
}

.table .badge {
  font-size: 0.7rem;
  padding: 0.35em 0.65em;
}

/* Enhanced dropdown styles */
.dropdown-menu {
  border: none;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  border-radius: 8px;
}

.dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
  color: #007bff;
  transform: translateX(4px);
}

.dropdown-item i {
  width: 20px;
  text-align: center;
}
</style>





